import {PDFDocument} from 'pdf-lib';
import ReactDOMServer from "react-dom/server";
import { Canvg } from 'canvg';

const generateSVGElement = (
    clientFirstName: string,
    clientLastname: string,
    clientEmail: string,
    courseName: string,
    description: string,
    currencySymbol: string,
    discount: number,
    paidPrice: number,
    AmountCharged: number,
    fullPrice:number

):any => {
    const generateInvoiceNumber = () => {
    return `DYNF`+Math.floor(10000 + Math.random() * 90000);
    };
    const priceSplitter = (number: any) =>  number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    function formatDateToYYYYMMDD(date:any) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1);
        const day = String(date.getDate());
        const hour = String(date.getHours());
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        return `${day}/${month}/${year} ${hour}:${minutes}`;
    }

    const splitNames = (fullName: string) => {
    fullName = fullName.trim();
    if (fullName.length < 3) {
        return { firstSplit: fullName, secondSplit: '' };
    }
    const splittedNames = fullName.split(/\s+/);
    const firstSplit = splittedNames.slice(0, 2).join(' ');
    const secondSplit = splittedNames.slice(2).join(' ');
    return { firstSplit, secondSplit };
    };
    let PaymentType = ''
    let Currency = 'USD'
    if(description==='full'){PaymentType="Full Payment"}
    if(description==='firstinstallment'){PaymentType="First Installment Payment"}
    if(description==='secondinstallment'){PaymentType="Second Installment Payment"}
    if(currencySymbol==='€'){Currency="EUR"}
    if(currencySymbol==='₦'){Currency="NGN"}
    if(description ==='secondinstallment'){discount=0}
    const {firstSplit, secondSplit} = splitNames(courseName)
    let AmountSaved = fullPrice * discount * 0.01
    let AmountPaid = paidPrice
    let Subtotal = paidPrice + AmountSaved;
    let Total = fullPrice
    let Balance = fullPrice - Subtotal
    let Paid = Subtotal
    if(description==='secondinstallment') {
        Balance = 0.00
        AmountPaid = AmountCharged
        Subtotal = fullPrice
        Total = fullPrice
        Paid = fullPrice
    }
    const InvoiceNumber = generateInvoiceNumber();
    const InvoiceDate = formatDateToYYYYMMDD(new Date())


    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 612 792" enable-background="new 0 0 612 792" xmlSpace="preserve">
   <g>
       <g>
           <defs>
               <rect id="SVGID_1_" y="1.5" width="612" height="791.7"/>
           </defs>
           <clipPath id="SVGID_2_">
               <use xlinkHref="#SVGID_1_"  overflow="visible"/>
           </clipPath>
           <g clip-path="url(#SVGID_2_)">
               <rect y="1.5" fill="#FFFFFF" width="612" height="791.7"/>
               <rect x="26.2" y="470.1" fill="#F6F6F6" width="560.6" height="116.5"/>
               <rect x="26.8" y="470.8" fill="none" stroke="#323232" stroke-opacity="0.5" width="559.5" height="115.3"/>
               <rect x="25.1" y="376.4" fill="#DDFFE0" width="169.4" height="38"/>
               <rect x="25.7" y="377" fill="none" stroke="#323232" stroke-opacity="0.5" width="168.3" height="36.7"/>
               <rect x="412" y="376.4" fill="#DDFFE0" width="174.9" height="38"/>
               <rect x="412.6" y="377" fill="none" stroke="#323232" stroke-opacity="0.5" width="173.8" height="36.7"/>
               <rect x="194.5" y="376.4" fill="#DDFFE0" width="217.5" height="38"/>
               <rect x="195.1" y="377" fill="none" stroke="#323232" stroke-opacity="0.5" width="216.4" height="36.7"/>
               <path fill="#DDFFE0" fill-opacity="0.96" d="M988.6-206.2c142.9,205.7,288,490.1,217,547.5c-69.8,56.1-354.5-116-610.3-135.9
                   c-255.7-20-496.6,78-642.7-29.3c-145-107.3-195.3-419.7-82.5-604.2S274.1-636.3,490-586.4C706-535.4,845.7-410.7,988.6-206.2z"/>
               <path fill="#DDFFE0" fill-opacity="0.96" d="M-405.9,1112.6c-142.9-205.7-288-490.1-217-547.5c69.8-56.1,354.5,116,610.3,135.9
                   c255.7,19.9,496.6-78,642.7,29.3c145,107.3,195.3,419.7,82.5,604.2s-403.9,208.3-619.9,158.3
                   C-123.4,1441.9-263.1,1317.2-405.9,1112.6z"/>
               <rect x="26.2" y="30.6" fill="none" width="64.5" height="22.8"/>
               <path fill="#0C3F0C" d="M457.8,45.2v22.2h-5.1V45.2H457.8z M465.4,58v9.4h-5.1V50.7h4.9v3.2h0.1c0.3-1,0.9-1.9,1.6-2.5
                   c0.8-0.6,1.7-0.9,2.7-0.9c1,0,1.9,0.3,2.6,0.8c0.8,0.5,1.3,1.3,1.7,2.2c0.4,0.9,0.7,2,0.7,3.2v10.6h-5.1v-9.4
                   c0-0.8-0.2-1.5-0.5-1.9c-0.3-0.5-0.9-0.8-1.5-0.8c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.5,0.5-0.8,0.9
                   C465.6,56.9,465.4,57.4,465.4,58z M491.1,50.7l-4.8,16.6h-6l-4.8-16.6h5.4l2.3,11h0.1l2.3-11C485.6,50.7,491.1,50.7,491.1,50.7z
                    M499.1,67.6c-1.5,0-2.8-0.4-3.9-1c-1.1-0.8-2-1.8-2.5-3c-0.5-1.3-0.9-2.8-0.9-4.4c0-1.6,0.3-3.2,0.9-4.4c0.5-1.3,1.4-2.3,2.5-3
                   c1.1-0.8,2.4-1.1,3.9-1.1c1.5,0,2.8,0.4,3.9,1.1c1.1,0.8,2,1.8,2.5,3c0.5,1.3,0.9,2.8,0.9,4.4c0,1.6-0.3,3.2-0.9,4.4
                   c-0.5,1.3-1.4,2.3-2.5,3C501.9,67.3,500.6,67.6,499.1,67.6z M499.1,63.3c0.4,0,0.8-0.1,1.1-0.5c0.3-0.4,0.5-0.8,0.8-1.4
                   c0.2-0.6,0.2-1.4,0.2-2.3c0-0.9-0.1-1.6-0.2-2.3c-0.2-0.6-0.4-1.1-0.8-1.4c-0.3-0.4-0.7-0.5-1.1-0.5s-0.9,0.1-1.2,0.5
                   c-0.3,0.4-0.5,0.8-0.8,1.4c-0.2,0.6-0.2,1.4-0.2,2.3c0,0.9,0.1,1.6,0.2,2.3c0.2,0.6,0.4,1.1,0.8,1.4
                   C498.2,63,498.7,63.3,499.1,63.3z M508.6,67.3V50.7h5.1v16.6H508.6z M511.1,49c-0.7,0-1.3-0.3-1.7-0.8c-0.5-0.5-0.8-1.1-0.8-1.9
                   c0-0.8,0.2-1.4,0.8-1.9c0.5-0.5,1.1-0.8,1.7-0.8c0.7,0,1.3,0.3,1.7,0.8c0.5,0.5,0.8,1.1,0.8,1.9c0,0.8-0.2,1.4-0.8,1.9
                   C512.4,48.7,511.9,49,511.1,49z M523.3,67.6c-1.5,0-2.8-0.4-3.9-1c-1.1-0.8-2-1.8-2.5-3s-0.9-2.8-0.9-4.4c0-1.6,0.3-3.2,0.9-4.4
                   s1.4-2.3,2.5-3c1.1-0.8,2.4-1.1,3.9-1.1c1.4,0,2.6,0.3,3.6,0.9c1,0.6,1.9,1.4,2.4,2.5c0.5,1,0.9,2.3,0.9,3.8h-4.8
                   c-0.1-0.9-0.3-1.5-0.7-2c-0.3-0.5-0.9-0.6-1.4-0.6c-0.4,0-0.9,0.1-1.2,0.5c-0.3,0.3-0.5,0.8-0.8,1.4c-0.2,0.6-0.3,1.4-0.3,2.3
                   c0,0.9,0.1,1.6,0.3,2.3c0.2,0.6,0.4,1,0.8,1.4c0.3,0.3,0.8,0.4,1.2,0.4c0.3,0,0.8-0.1,1-0.3c0.3-0.3,0.5-0.5,0.7-0.9
                   c0.2-0.4,0.3-0.9,0.3-1.5h4.8c0,1.5-0.3,2.8-0.9,3.8c-0.5,1.1-1.3,1.9-2.4,2.5C525.9,67.3,524.7,67.6,523.3,67.6z M539.1,67.6
                   c-1.5,0-2.8-0.4-3.9-1c-1.1-0.6-2-1.6-2.5-2.9s-0.9-2.8-0.9-4.6c0-1.8,0.3-3.2,0.9-4.4s1.4-2.3,2.5-3c1.1-0.8,2.4-1,3.8-1
                   c1.1,0,2.1,0.3,3,0.6c0.9,0.4,1.6,1,2.3,1.6c0.7,0.8,1.1,1.6,1.4,2.7c0.3,1,0.5,2.3,0.5,3.5v1.4h-12.9v-3.3h8.1
                   c0-0.5-0.1-0.9-0.3-1.3c-0.2-0.4-0.4-0.6-0.8-0.9c-0.3-0.3-0.8-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.3-0.7,0.5-0.9,0.9
                   c-0.2,0.4-0.3,0.8-0.3,1.3v3.5c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.4,0.8,0.9,1c0.3,0.3,0.8,0.4,1.3,0.4c0.3,0,0.7,0,1-0.1
                   c0.3-0.1,0.5-0.3,0.8-0.5s0.3-0.5,0.4-0.8h4.7c-0.1,1.1-0.5,2.2-1.1,3c-0.7,0.9-1.4,1.5-2.4,2C541.6,67.5,540.4,67.6,539.1,67.6z
                   "/>
               <rect x="558.5" y="38.2" fill="#97E09E" width="27.3" height="35.5"/>
               <path fill="#DDFFE0" d="M574.8,38.2h10.9v12.7h-10.9V38.2z"/>
               <defs>
                   <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="574.8" y="36.9" width="12" height="13.9">
                       <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
                   </filter>
               </defs>
               <mask maskUnits="userSpaceOnUse" x="574.8" y="36.9" width="12" height="13.9" id="path-22-inside-1_3182_2959">
                   <path fill="#FFFFFF" filter="url(#Adobe_OpacityMaskFilter)" d="M574.8,38.2h10.9v12.7h-10.9V38.2z"/>
               </mask>
               <path mask="url(#path-22-inside-1_3182_2959)" fill="#97E09E" d="M585.8,38.2h1.1v-1.3h-1.1V38.2z M574.8,39.5h10.9v-2.5h-10.9
                   V39.5z M584.7,38.2v12.7h2.2V38.2H584.7z"/>
               <path fill="none" stroke="#FFFFFF" stroke-linecap="round" d="M566.1,58.5h13.1"/>
               <path fill="none" stroke="#FFFFFF" stroke-linecap="round" d="M566.1,63.5H577"/>
               <path fill="none" stroke="#FFFFFF" stroke-linecap="round" d="M566.1,68.6h7.7"/>
               <rect x="25.1" y="414.4" fill="#F6F6F6" width="169.4" height="55.7"/>
               <rect x="25.7" y="415" fill="none" stroke="#323232" stroke-opacity="0.49" width="168.3" height="54.5"/>
               <rect x="194.5" y="414.4" fill="#F6F6F6" width="217.5" height="55.7"/>
               <rect x="195.1" y="415" fill="none" stroke="#323232" stroke-opacity="0.49" width="216.4" height="54.5"/>
               <rect x="412" y="414.4" fill="#F6F6F6" width="174.9" height="55.7"/>
               <rect x="412.6" y="415" fill="none" stroke="#323232" stroke-opacity="0.49" width="173.8" height="54.5"/>
               <text transform="matrix(0.8627 0 0 1 26.9272 110.1235)" font-family="'Verdana-Bold'" font-size="15.2007">Doyenify OÜ</text>
               <text transform="matrix(0.8627 0 0 1 27.4766 134.0688)" fill="#444343" font-family="'Verdana'" font-size="15.2007">Juhan Sutiste 52 - 35 Haabersti linnaosa,</text>
               <text transform="matrix(0.8627 0 0 1 28.4766 155.23)" fill="#444343" font-family="'Verdana'" font-size="15.2007">Tallinn Harju maakond 13516</text>
               <text transform="matrix(0.8627 0 0 1 28.4766 174.0786)" fill="#444343" font-family="'Verdana'" font-size="15.2007">Estonia</text>
               <text transform="matrix(0.8627 0 0 1 28.4766 192.9971)" fill="#444343" font-family="'Verdana'" font-size="15.2007">+372 5670 4920, +2347033416581</text>
               <text transform="matrix(0.8627 0 0 1 27.3838 266.7783)" font-family="'Verdana-Bold'" font-size="15.2007">Client Name: </text>
               <text transform="matrix(0.8627 0 0 1 129.686 266.7783)" font-family="'Verdana'" font-size="15.2007">{clientFirstName} {clientLastname}</text>
               <text transform="matrix(0.8627 0 0 1 26.229 287.0459)" font-family="'Verdana-Bold'" font-size="15.2007">Address:  </text>
               <text transform="matrix(0.8627 0 0 1 27.8682 309.0024)" font-family="'Verdana-Bold'" font-size="15.2007">Contact: </text>
               <text transform="matrix(0.8627 0 0 1 95.8076 307.7354)" font-family="'Verdana'" font-size="15.2007">{clientEmail}</text>
               <text transform="matrix(0.8627 0 0 1 47.6108 436.4316)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{firstSplit} </text>
               <text transform="matrix(0.8627 0 0 1 47.6108 454.6738)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{secondSplit}</text>
               <text transform="matrix(0.8627 0 0 1 78.3218 400.6318)" font-family="'Verdana-Bold'" font-size="15.2007">PURCHASE</text>
               <text transform="matrix(0.8627 0 0 1 263.3789 400.6318)" font-family="'Verdana-Bold'" font-size="15.2007">DESCRIPTION</text>
               <text transform="matrix(0.8627 0 0 1 472.9961 399.8408)" font-family="'Verdana-Bold'" font-size="15.2007">AMOUNT</text>
               <text transform="matrix(0.8627 0 0 1 516.3008 446.9209)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{currencySymbol} {priceSplitter(AmountPaid)}</text>
               <text transform="matrix(0.8627 0 0 1 210.9214 446.9209)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{PaymentType}</text>
               <text transform="matrix(0.8627 0 0 1 410.2559 492.8311)" font-family="'Verdana-Bold'" font-size="15.2007">Subtotal:</text>
               <text transform="matrix(0.8627 0 0 1 410.2559 510.6787)" font-family="'Verdana-Bold'" font-size="15.2007">Discount:</text>
               <text transform="matrix(0.8627 0 0 1 410.2559 529.5664)" font-family="'Verdana-Bold'" font-size="15.2007">Total:</text>
               <text transform="matrix(0.8627 0 0 1 411.4609 549.8311)" font-family="'Verdana-Bold'" font-size="15.2007">Paid:</text>
               <text transform="matrix(0.8627 0 0 1 411.4609 568.9492)" font-family="'Verdana-Bold'" font-size="15.2007">To Balance:</text>
               <text transform="matrix(0.8627 0 0 1 517.4229 491.5625)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{currencySymbol} {priceSplitter(Subtotal)}</text>
               <text transform="matrix(0.8627 0 0 1 515.1006 509.4121)" fill="#292727" font-family="'ArialMT'" font-size="15.2007"> {discount}%</text>
               <text transform="matrix(0.8627 0 0 1 517.4229 529.5664)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{currencySymbol} {priceSplitter(Total)}</text>
               <text transform="matrix(0.8627 0 0 1 517.4229 548.6816)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{currencySymbol} {priceSplitter(Paid)}</text>
               <text transform="matrix(0.8627 0 0 1 517.6504 567.6816)" fill="#292727" font-family="'ArialMT'" font-size="15.2007">{currencySymbol} {priceSplitter(Balance)}</text>
               <text transform="matrix(0.8627 0 0 1 238.2432 719.9561)" font-family="'ArialMT'" font-size="15.2007">Have any questions? </text>
               <text transform="matrix(0.8627 0 0 1 178.1357 741.4912)" font-family="'ArialMT'" font-size="15.2007">Contact +372 5670 4920,+2347033416581 </text>
               <text transform="matrix(0.8627 0 0 1 214.2002 761.7578)" font-family="'ArialMT'" font-size="15.2007">or info.doyenify@gmail.com</text>
               <text transform="matrix(0.8627 0 0 1 361.7979 116.5708)" fill="#292727" font-family="'Verdana-Bold'" font-size="15.2007">Invoice Date: </text>
               <text transform="matrix(0.8627 0 0 1 490.1465 116.5708)" fill="#292727" font-family="'SegoeUI'" font-size="15.2007">{InvoiceDate}</text>
               <text transform="matrix(0.8627 0 0 1 361.1895 138.7998)" fill="#292727" font-family="'Verdana-Bold'" font-size="15.2007">Invoice #:</text>
               <text transform="matrix(0.8627 0 0 1 487.9375 138.7144)" font-family="'ArialMT'" font-size="15.2007"> {InvoiceNumber}</text>
               <text transform="matrix(0.8627 0 0 1 361.7363 160.7949)" fill="#292727" font-family="'Verdana-Bold'" font-size="15.2007">Payment Terms: </text>
               <text transform="matrix(0.8627 0 0 1 490.6934 160.1621)" fill="#292727" font-family="'SegoeUI'" font-size="15.2007">Upon Due Receipt</text>
               <text transform="matrix(0.8627 0 0 1 361.7363 181.2563)" fill="#292727" font-family="'Verdana-Bold'" font-size="15.2007">Currency: </text>
               <text transform="matrix(0.8627 0 0 1 490.6934 182.3296)" font-family="'ArialMT'" font-size="15.2007">{Currency}</text>
           </g>
       </g>
       <g>
           <defs>
               <rect id="SVGID_3_" y="25.3" width="612" height="791.7"/>
           </defs>
           <clipPath id="SVGID_4_">
               <use xlinkHref="#SVGID_3_"  overflow="visible"/>
           </clipPath>
           <g clip-path="url(#SVGID_4_)">
               
                   <image overflow="visible" enable-background="new    " width="112" height="34" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAiCAYAAACHpl23AAAACXBIWXMAAAsSAAALEgHS3X78AAAA
   GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFfdJREFUeNrsW3twXFd9Puee+9q7
   b61WL0uyZEuyLVl+RMbGmDRySRMcQhqYyqVlJkOYAabQtJ1paf4oM/gPCrTQSUsKbRggFJqmsVrc
   OmAnHlMr8SuxLRs/JNuSLMuWVitpte+793Xuo+fcvbuRHUEaaDJ5XXut9d69557ze3y/7/udKwa8
   d7ytD+Y9E7y9D/Y9E7y5h+M40HtLfzruGwidX3c8+Hq+fOnSJf6nyVGfJpegpqiwvQ7ZPMvrD+98
   WHvPNa/tuIMTB/lfnJgMTGUmeMwbbIAPOLH61drKYJf8qf5+/ddx5OvKwJdmRgPPHf6XJpW3XOh9
   aQTZG9s3pshb7d3unKGpKeFa8rQU88XtTi6u9PT04KUOGZoaEp4eOtB49fJICPGIcSwbQpFx2OvD
   VpRvVGLB4Cz5mvKGOtAyTEYzVR74yjCgabyDWQzf7dk1ePhw6KnjP1yRyi3wAGCwvqmr2Kf1JSsO
   eeLME9wPB59ecXluMoT8gLGBBQBH8dOChg4YIcyjVX195htOYnRWg4ZtuA7DGAP6BwD/u9p5Z5wz
   3ItTz9fM5JKiJarICqro7NyV0JWRVLQa+KoVuJa+ERBd5MLuZ1jB7lto8c6mjtWFnsqJN5rEcOXb
   A46jN6fvS+9qB4pAhNdvzIuO6EAsEfuQwDZEP8zk50UPXtFD33skosASyxGjkdNAAKK9uq5d4SBn
   B8Jx+wM1H8j+ukTmdTsQe06k2QcB/64nJymQsltiMXV+MikijmOogRgN2XWoxY3sCTDBZjJ5sWI9
   DkggEqrR+7d+OPH5/gHVI5LWm6YDIcM71IWcl4uK8u524E6402xf1Zte3bimxJV4M2DW4C0r1uQ7
   WtYWKLm5PHwZlVQZcR5CmpbpBMSwEY93GyTrLPIyfxMZ8boy0DBFx0AOZL0M5MkfSXpPIvzlA5+W
   H+dKN2rAdmFCztv3D2zT+0Cf65j9if3AVnUIIOfCF4VRDjh2vKfHflOFPI2mxw8+CWnt8zDUK4hv
   PRJD5/qbRPXrRqXyvXRyX+N2YS4gATqIhYDmICmAkLws04JjYBi+IQ4kk2CeHR4WNZDlsLrANK3Z
   iPvjPRpN9W/85J8gZU/UiTSSTGw6ilL6Zd0GdHLmJJdL5LgsthHnE2wRqPijfR/VyTm7skh6Pwrl
   Q+SfoLcoEr2O951lo/TIkSNsf3+/a6shMOSO0w/6raWGI+Nyx68eF1NqCuVyAPR2tRhiVjSpPltq
   ZG+u7nxdSUDuW9YGg2BgYMCm+k2l0gnUgIho4+3N213ou329w2DYtSX5Cc6cOQP6+vossiYmNXyY
   fG64ES8Rm6lktb4QZNoupHlyXWV9jjcH+1cFnqs3h4YQWXv1umoUfOvAASGzOBK+ODNSk84uiLKW
   JZHjg5BhnHioXl/b3pYPBerhsyf21pezEAOmJNgbO7cm/vmPvrlQccbjB58KnJs7EV6cyYbSWt6F
   fkMrSw8e8U40FtN7mhrzW9ZtyQ5sH9B/cHy//8hz/92UtUscE2IcW7NhiPeZGzvWJrUBrbgH7rnF
   iY89+VjkxMxYvWJlOCqGDc4PJOgz7u7bkXxk1yeL3x38bujUwlgkMTsezqMcciwHUsYeIMwvJoZw
   e0dHsSO+IpfZlZHp2FQGPP6V77amjKxkI5tEDGs3Rev1puZ2+ebYuD+RSvqLuMiwCEGGQ3Z9KKZ3
   dqzOr3v/yszD7eUO1J4n/7bh2IXTcT7AAxtpMIyi+Hd3PZD62aF9dXkzx6WUHEvthT0I9SO/I1kR
   a1tXr9bsq7NpKUImgpQSxlesSN155525SputcoyPjwtzc3P16XQ6YBgGEEWROttyo2bvpb38yeGz
   tRcnTtfM59O8FOaALYruGCzQ4Lw268tfL/E+7ooNOODpP0KhbWZpxKPB4cHAvpPPNGtA5XWsMfS7
   HIEOJFL4UAjVssBiaUYaGpnhb8xnA4n5xML9D96vHjn6vDU3P+5nKdSQIzmHBROi+F7wPXkP2HML
   Ovzxt78UnixM+lmRBAWVUjgPAmyb0rtuhfHY849F/2f0dF2yNC+xyCjDFsLEJbRVZKIFnEGzV08I
   iUSzdF/oEwkynjwxMcGkkcHN4UW+osSKeZVLqvNSbnGBBX4yf2yRHLIo8qAbuevS3PmkWNByPMm0
   BMk089Gn9rDzVpKXCMPEmkKw1IYzxTS7aCpcTkmxZd1cdh61A8EsWMIGO5dM+mvaojbRidDP+0FJ
   JavOZGwyrr5lyxZlaeYdPXo0RBwYJjDMl8mjAhBCMkuN8mdPfzV66eqpWAnLLHVeRe8RjuRgN7Mx
   1DQFaRZG5frHuTDqiCxkRMjs3bsXff1nXw89f/xMverIInZ1YnkcOgbhXoC3IPl+ufdqcoC9Id8M
   pIcLSA9Is5t6VuWS+oyU1YqcRCIVkDksKjP+r+37doTMj2okmy7i0Pwh39X5sZBDnedZWwDI3rS1
   K//C1XPSmReO1y1CWWKJJoMadDhTMJvCEYx9jJNblAXaf2RFH5yS56Wfn9jXsI6JzzQ2NjpWscRw
   3qLp3G0SfCmlyPCkfJmY3JqAM4cc956cRDHWYi5dmQifil/NE7jP00slDlRhklqY84LRJEKdJdeW
   WSiusnfIQGcilwT1hRbY5K8Ftm4z5ACynAnMz7Mhsl61AqfDw8NsNpsNW5ZVLXmCINgNDQ15dmpq
   ip+cGKuV7SKHkeLegN5GRGEr6gg6FJCpohJXkBXewiSmaRSBchfBJJPgBM7Jilnh7LnxuqK5QCLf
   cZ1LpysZflPyBXVeEiygFFHGKIgaUhFdgoMwzCgl6dyF4/UfufuTiabJm7nFm6MxEsQM1SZ5gNnh
   6RM1Pxzyl7xeK3xu34uRBS3N+UQ39Yhx/M7Kxs68r6ZTf+nF/2xMwgUpRBykEMysjbYoD73vY8nu
   xm51FIyCiZtz4ede+HmDjlWeGnQsMxP4r8uHog+23JM1BKOsxEh2VJzIMUHcGW0txkIhbU5RhNnM
   9aCOC7zbHSPfUfU8Gp47GxoCf1g0DROSmHadSDMNGMSRloJDvpYC8oe4bGrGbwPMVDIjgII4EmxU
   bcWGSsGw2YhfQNAUGIuBNkJMXs1HZmdnCxUnkkzzE+f5bdt2xyD/d1iWVYPBYJo9cvlIcDYzLTgi
   zRrJjZKQ5bN2dGxJxTqlDElt2qPjro0nI8MXz9ZmccZNP+pG3YuGZK4QSKSnfTS6Mae43gs7vHlX
   32/Nr4zHc73BXosUd+7GjcXwiZeO16vUiRIdQQGT00lp9NJZvn/Lh7KLuXRgXrnhc1UmmcrCfMZ3
   9vpYcK+zF//4wiHx4vVfhFxopDcg10t2wNzQ3pXJXZvms/Ki5CBa7xSS9abTs36Nsqp7ByaeZ8No
   DdzU2KqP3ZzQrly5xJG1QtYy4fnpEWlHaXNRs8rZUibWBCct1vpg7x2Luz7x5QVClejc2X//8U+j
   5ydPNRUoCpHDF2ThfCbNg6khluVZx0sw1/kGcXOmlLE+/xcfmTYuGMLXnvlWewFxAj1LkaG+cYX8
   mY/tngVtwIyPxJlEIlE/PT1X6wv5SFmwIOMwvtHR0dqmpqZpWpqeffbZKKl7qNqasyy7paUlQ2AW
   s6duXPAbBJIkj5jAInS61ndkvvLQXyWXsEBMBtK+kPkSemnyRB3HlfugHB8CWOfhDTXt1xBE9HPO
   E/udazZlvzzwxfklrArvcfZo62fvEM/cPBEltQCW48VEuYIsfXrHA3OZhfziM8d+tALzpH7SUEYy
   N5OYqU0NNasXb54P55ii6EY5uYtq88762s78/Q/eWfrm3//riiKBPCCWI5zS9hdPvxx7+eypGgpo
   mCSYTmq+Y+vQEEvQGwOausznHIv3E/KyaLlFyk3C5littq5hZWYnYd4uSdmzx9p6zz3FkyMnMYYV
   FCofzWazQzMQVJCJ6gkynq7EIRX5RAfyFkBM5Sznl8oyIj1mfa79c+7458+fz+RVNWhrmkiAANJM
   I2QlOjIyktE0DZmmSTPQDTJyzolGowXi9JzbiZHVIstVm2TkaiQ4jMJrt7Mg+v87Nm8sVTuiLlQQ
   FUhkoGyoHIWQikSkxu9qXaXcTokp66utD6n0Hhi/0prTCCzS9z292/Mt0Uat0nGlJ5OFhO/S5Hhd
   MjEVdpgym6WfR1QRb13TlSM1yNJwFlGneWXXnYWuaEyhWEDpTBIV5CTS8xnG0UqQllilDBKA8Eom
   m0izlGnTz7mKtmUFq6jWV+dOHOgGMs8HvHlhz1zGbU1G4CITrYGalPKubyIZWWk+YuBYBhRFwRVL
   lWPDhg1aIMxTyFxqL5RMJutI7Yvpul5dGXEmrqmpyRGJ496QxaZUbo15c6J1LRqrWVaL0E1cz0Nu
   tBrYgFg3IGORwkd3JzwmADkI5KzNLKdjvrr/Hxz3zh4MLz19X2envucn30jnzmX5PFBc6u2Q4UYS
   V8M0exzbgZhUUEoANq3szUfvjsr0Os4qO69ifxcB2jvkgCjqBA7JWlRgYTIp0Y0WStkdjuWgPxKw
   VsY6dIayaW/u2I0sATS0tt5ig7iuOzxxmEvOvOizzTL0uhBaafOTcyTHCEqL1et5UhMNVKYvJiWG
   pul09fUtHd/2AV9O4ZQAcZbfg0m4uLgYJg4j8cVUs8/v98vbt28vVpKDDUghE2RewX+yVGZyaio0
   ODiYXxpigyOD3LHTJ4N0ghXGRhlXroCdGsibZdZZDm0yX3gtMeIndJijOF1x3ggY4SYSU36HwJnE
   lI1FX7bow5WM/72uXbmRqfOhwmI+BCjzo+c5jcEWrhouIMXwB7v6MrvhbldQf/aJPzGmM7Ashsk0
   eNtyVq/tzP/1h/504XbBPnhyUAAhYA30DFD4coiMIDKMwKzKVWMTuNV99JbgU5tVx1RMB1Rah2Qu
   fpGzQUcHMA+ZVVZMzcAgSil0z0GzQCA12UDlLKSJgmjAg6FbOjnkKBGRvkig00ecyHgOc5mpa3Oq
   YRAyW1tb0+T71chn1vW0lhjDsoFURmmqxaaVmeBRY6Ru/5n9En2M4kfnn/cfPj7cMKPMhCXa/PTw
   nmhPJ8xHnPqG2gIlLa4J6F/ylZmFqdBTI/vq9k6f8B0gIpSQEOnvvvOD+qsLYyGWwAglG5ikrCiE
   rHUtnVW4Xb9+Pe5p2JSjWy64aivPOOTePMm+Oqm1MNA/UNVJbfGuEstIlhtEhIFSDXrp5PHIjw8d
   kqhM8ro96LHnvx/5wYH9rYeOnFqx/+pxGukMYXOQXwKDErGDjTg4dzNwS6tLTskMz3tS0asVqqnC
   8YkJwmiqseWeVw2VyeFQFYF0T1JQ55VIUJaQBZdrxxFWmScO02imca/UA0BtTj/z+Xylbdu2ybe0
   0j7cv6Nw9IUX9RktKbJIgrhsWHTm6vH4mYuno03xMJ5NpQgX4FjbE+fAiwjd0BjVLjH3RjbnRiKX
   S9fy02GOK6+EyFX26PmX685d/UXUVxOxc4qMgFIimtoT+LisEVfVtckbmbalexrOl//gz7PXvnkl
   OJ6djFIIfWULizBP5Nc3tMZzS9tsjVF/qbVphXLx5khIKjMUsFCY8z957B/bjswcJHQ7Yi4mp4Rr
   09MEqUQudzPlTPxo2n907cWFj+/cWCwpisPBSoaT63UdNMjyq8qIzdqwYla6/jKEji/ZJy0fQZqB
   kl6tgRTIsLeHyhNdKAJh2VYZRasjR46kCHFpwtgrSFwZqYjuw8SB2dvbi0wP6MGbu/vmasV63e1z
   ekpQx0VG5wv8zOK034YaT53Hec6rRBMlI5LkB7t27TL6tmxN1UVXy5WnOuiEiXphCnZemF+c8Nn5
   Od4GRdd52HPeinhrcevatQv0+tui0eped0cO2oK3deV9Tij4+9r6so8OPFpc+v1P9X9Kv2/bnfPd
   TeuKlbJKmwx5nBXPj5+Jvnz2cPxaciIEQpQM5AlLNdys4xyLQHALIKEJq9yMBDDDMs5cIPCqLBER
   7Ty9sqPuh5zdCTppAi5xouTVnbwH27MAAWRXyB3giTMIRI8Njy3bzI7H44VwOHzLM0akDtqk9hXI
   Ib9qP5Cm7l3xzYW7tmxfqA1G9DLB4lxNyHl4iF3Z5TfXdWwuYiwBKvfpy7B0aBp5t/Ov3f3Z4sDa
   LbMNjZ2qqfkdSscr7SM39ChEc+XrGBC0Oxp7C79/333JR3Y9UlyugZstFn1uO84LGPoj5o8bD95z
   z6uikF4/sW1C/uiOu+aaQ90lOn4+71V1jquSZkyquqnxTliM6P2bdsx/9aEv5OLNmm2AgDsv7L1s
   017WuNQximcf+sqZZSjUBMDgyjm6boMDGid4OyJNLoRiz5aORrQqua6rr2tZoijLskhqYBXVafbR
   2ldfX19lnq/ajdi5c6dJoiXd0dqr/uQ/nqldNLM+xjKQQWbMMrzVGGnV7v2dj6drYgDcvLxgB/x+
   yBKto5IIrGUalbJEcI1aHB8fv/bUxcPhsxeOhywTc7pRZHWfAHmibqEP4Tq2Qf/tzTtzq4V4Yef6
   ncs+yENr7vf+7TuxauqROwhc0N7Uckdme/P2ZZ+A85rehQMHDujncmOR06PnArqlCNgoId0SYIAT
   TF/EjzvaeuTd/TtzdByPPMAmMSb76eM+1HERAOqjXYowPX3rTkio21oXXF+E+oTJOD6H9Tl2U3N3
   KZ/P2wKUtJbYqmLE8jk6yS6BjVidVre7tqARs5v5FlnVZVYQDKDzQdAQXSenBlPOso8eHjwYL5VK
   PCUvlewjxCXb19cnLxfor4o02tcEzYC/niqytbFaEBehFSwGjf7+fsvbvmGCIAjFERESrHbotsnt
   GUEnQlmrqInslFlglSIRz4SVtdW1mcE+MtZtWz+3b2d95vFHm0amLsZtv+Y+BEThtjbQrNzVd8f0
   F+/94ms+hFO+/wgXthLcVTWF6P2b6nxmrVRrnuo4hZfucLhbNGAIkTnRrSDXHkXQ51RE/C1bRsPl
   LaM+TwIMgkGHMmFqs+7ubuTZw91Sqmzoetey5FpIpd+v2iojrF0aGxvroFthlZYZIS86IVo3du/e
   LS+7F/lW24z9m2PfD+5/9kCrCYsi4MoFlbcCeNva989tFbvTZCEWeAceTzzxBBeNRhsJfNZWdB+V
   g4FAYOGBBx5I/rKAf0v9bgSN8sTIWFTHed7dP/OYp8jUqB+5867CO9V5dN2rVq2SiOOCFefR7CMv
   va2tLf+rNnmZt9IiDs1fkEZnJsM2bzGUDdL+nFBCdvfKtkJ/W7/+Dn6shvANI0LBpqJ5aXEOhULF
   DRs2qP+vT6W9UQft+O97+sm4rBXKGpY4jz702lrbXrq3/4O5N/MZlzc7cI8dOxZUVTVMOzCuviyL
   dr23tzf9yx4reUs5kC7ip4MvBkdvXg/SJ7/dp5bdz6G5qqM9e6pjF34HZx+bSCRqCPNEBD5p74w6
   zKJdmebm5tf8nZO3xK+XDQ4OMo1iA7O2vUvRsKUzrOkgFjkNgZjaEW8sPvwaUfh2PugjHUS8U0e5
   rFejzXaEDCLm8/8X1PlfAQYA7yCpKiDAu+cAAAAASUVORK5CYII=" transform="matrix(1.0929 0 0 1.2667 244.8 624.5661)">
               </image>
           </g>
       </g>
       <g>
           <defs>
               <rect id="SVGID_5_" y="25.3" width="612" height="791.7"/>
           </defs>
           <clipPath id="SVGID_6_">
               <use xlinkHref="#SVGID_5_"  overflow="visible"/>
           </clipPath>
           <g transform="matrix(1 0 0 1 -1.157179e-008 3.634792e-006)" clip-path="url(#SVGID_6_)">
               
                   <image overflow="visible" enable-background="new    " width="308" height="84" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAABUCAYAAAAMAstxAAAACXBIWXMAAAsTAAALEwEAmpwYAABC
   82lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0w
   TXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRh
   LyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEz
   LTEyOjA5OjE1ICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMu
   b3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJk
   ZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFw
   LzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMv
   MS4xLyIKICAgICAgICAgICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bo
   b3Rvc2hvcC8xLjAvIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNv
   bS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5j
   b20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6c3RSZWY9
   Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiCiAgICAgICAg
   ICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAg
   ICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx4
   bXA6Q3JlYXRvclRvb2w+QWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKTwveG1wOkNyZWF0b3JU
   b29sPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAyMi0wOC0xOFQxNTo0NDozMiswMTowMDwv
   eG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDx4bXA6TW9kaWZ5RGF0ZT4yMDIyLTA4LTE4VDE1OjQ5
   OjI3KzAxOjAwPC94bXA6TW9kaWZ5RGF0ZT4KICAgICAgICAgPHhtcDpNZXRhZGF0YURhdGU+MjAy
   Mi0wOC0xOFQxNTo0OToyNyswMTowMDwveG1wOk1ldGFkYXRhRGF0ZT4KICAgICAgICAgPGRjOmZv
   cm1hdD5pbWFnZS9wbmc8L2RjOmZvcm1hdD4KICAgICAgICAgPHBob3Rvc2hvcDpDb2xvck1vZGU+
   MzwvcGhvdG9zaG9wOkNvbG9yTW9kZT4KICAgICAgICAgPHBob3Rvc2hvcDpUZXh0TGF5ZXJzPgog
   ICAgICAgICAgICA8cmRmOkJhZz4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBl
   PSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5ZXJOYW1lPkxheWVy
   IDE8L3Bob3Rvc2hvcDpMYXllck5hbWU+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5
   ZXJUZXh0Lz4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgIDwvcmRmOkJhZz4K
   ICAgICAgICAgPC9waG90b3Nob3A6VGV4dExheWVycz4KICAgICAgICAgPHhtcE1NOkluc3RhbmNl
   SUQ+eG1wLmlpZDo5ZWJiMWEzMi1hMDFmLTM1NDItYTVmMS1iMzJkNmI3ZmY0ZTI8L3htcE1NOklu
   c3RhbmNlSUQ+CiAgICAgICAgIDx4bXBNTTpEb2N1bWVudElEPnhtcC5kaWQ6ZDY0MmYxMTAtYTA4
   ZS0zOTRiLWE5YzAtMjU3ZTE0YzcyMjFmPC94bXBNTTpEb2N1bWVudElEPgogICAgICAgICA8eG1w
   TU06T3JpZ2luYWxEb2N1bWVudElEPnhtcC5kaWQ6ZDY0MmYxMTAtYTA4ZS0zOTRiLWE5YzAtMjU3
   ZTE0YzcyMjFmPC94bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ+CiAgICAgICAgIDx4bXBNTTpIaXN0
   b3J5PgogICAgICAgICAgICA8cmRmOlNlcT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFy
   c2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+Y3JlYXRl
   ZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAu
   aWlkOmQ2NDJmMTEwLWEwOGUtMzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RFdnQ6aW5zdGFuY2VJ
   RD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OndoZW4+MjAyMi0wOC0xOFQxNTo0NDozMiswMTow
   MDwvc3RFdnQ6d2hlbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRv
   YmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAg
   ICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVz
   b3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNvbnZlcnRlZDwvc3RFdnQ6
   YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6cGFyYW1ldGVycz5mcm9tIGltYWdlL3Bu
   ZyB0byBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wPC9zdEV2dDpwYXJhbWV0ZXJzPgog
   ICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VU
   eXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+c2F2ZWQ8L3N0
   RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0Omluc3RhbmNlSUQ+eG1wLmlpZDpi
   Njg2OWJhYi01ZjAwLWJiNGItYjdmYS1lZTlkNzE5YTY1YzI8L3N0RXZ0Omluc3RhbmNlSUQ+CiAg
   ICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjItMDgtMThUMTU6NDc6MTQrMDE6MDA8L3N0
   RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpzb2Z0d2FyZUFnZW50PkFkb2JlIFBo
   b3Rvc2hvcCBDQyAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAg
   ICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgIDwvcmRm
   OmxpPgogICAgICAgICAgICAgICA8cmRmOmxpIHJkZjpwYXJzZVR5cGU9IlJlc291cmNlIj4KICAg
   ICAgICAgICAgICAgICAgPHN0RXZ0OmFjdGlvbj5zYXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAg
   ICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAuaWlkOmVjMjlkYWVlLWU4ZmQtNTM0Mi04
   NmI5LTRjOWMzN2RmMzc3Zjwvc3RFdnQ6aW5zdGFuY2VJRD4KICAgICAgICAgICAgICAgICAgPHN0
   RXZ0OndoZW4+MjAyMi0wOC0xOFQxNTo0OToyNyswMTowMDwvc3RFdnQ6d2hlbj4KICAgICAgICAg
   ICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dz
   KTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmNoYW5nZWQ+
   Lzwvc3RFdnQ6Y2hhbmdlZD4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAg
   IDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RF
   dnQ6YWN0aW9uPmNvbnZlcnRlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RF
   dnQ6cGFyYW1ldGVycz5mcm9tIGFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5waG90b3Nob3AgdG8gaW1h
   Z2UvcG5nPC9zdEV2dDpwYXJhbWV0ZXJzPgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAg
   ICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAg
   ICAgIDxzdEV2dDphY3Rpb24+ZGVyaXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAg
   ICA8c3RFdnQ6cGFyYW1ldGVycz5jb252ZXJ0ZWQgZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUu
   cGhvdG9zaG9wIHRvIGltYWdlL3BuZzwvc3RFdnQ6cGFyYW1ldGVycz4KICAgICAgICAgICAgICAg
   PC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2Ui
   PgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAg
   ICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6OWViYjFhMzItYTAxZi0z
   NTQyLWE1ZjEtYjMyZDZiN2ZmNGUyPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAg
   ICA8c3RFdnQ6d2hlbj4yMDIyLTA4LTE4VDE1OjQ5OjI3KzAxOjAwPC9zdEV2dDp3aGVuPgogICAg
   ICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgKFdp
   bmRvd3MpPC9zdEV2dDpzb2Z0d2FyZUFnZW50PgogICAgICAgICAgICAgICAgICA8c3RFdnQ6Y2hh
   bmdlZD4vPC9zdEV2dDpjaGFuZ2VkPgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAg
   ICAgPC9yZGY6U2VxPgogICAgICAgICA8L3htcE1NOkhpc3Rvcnk+CiAgICAgICAgIDx4bXBNTTpE
   ZXJpdmVkRnJvbSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgIDxzdFJlZjpp
   bnN0YW5jZUlEPnhtcC5paWQ6ZWMyOWRhZWUtZThmZC01MzQyLTg2YjktNGM5YzM3ZGYzNzdmPC9z
   dFJlZjppbnN0YW5jZUlEPgogICAgICAgICAgICA8c3RSZWY6ZG9jdW1lbnRJRD54bXAuZGlkOmQ2
   NDJmMTEwLWEwOGUtMzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RSZWY6ZG9jdW1lbnRJRD4KICAg
   ICAgICAgICAgPHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOmQ2NDJmMTEwLWEwOGUt
   Mzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RSZWY6b3JpZ2luYWxEb2N1bWVudElEPgogICAgICAg
   ICA8L3htcE1NOkRlcml2ZWRGcm9tPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZm
   Ok9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpYUmVzb2x1dGlvbj43MjAwMDAvMTAwMDA8L3Rp
   ZmY6WFJlc29sdXRpb24+CiAgICAgICAgIDx0aWZmOllSZXNvbHV0aW9uPjcyMDAwMC8xMDAwMDwv
   dGlmZjpZUmVzb2x1dGlvbj4KICAgICAgICAgPHRpZmY6UmVzb2x1dGlvblVuaXQ+MjwvdGlmZjpS
   ZXNvbHV0aW9uVW5pdD4KICAgICAgICAgPGV4aWY6Q29sb3JTcGFjZT42NTUzNTwvZXhpZjpDb2xv
   clNwYWNlPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MzA4PC9leGlmOlBpeGVsWERp
   bWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjg0PC9leGlmOlBpeGVsWURp
   bWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1l
   dGE+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAK
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   IAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAog
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAK
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   IAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAog
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
   ICAgICAgICAgICAgICAgICAgICAgICAgCjw/eHBhY2tldCBlbmQ9InciPz779IBeAAAAIGNIUk0A
   AHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAFiHSURBVHja7J13vGVVef6/q+xy
   yi3TaCJVUAFFRREFRTRGo7GgKNZojCn2Envvxp4YjCVR0ICiAtbYRUEEERsGBEE6TJ9bT9t7r7Xe
   3x9rn3PvwDSGEQi/+/q5nxnGmXPW2WetZ73leZ9XsWRLtmT/39mHf3KarN60jquuv5rV69fSr/rY
   LKHVatFMGhz7gIfylr94gfq/9rnu0AW/6Qsfkwsu+TXJRIv2igmm5maZn58nSRIym9DrdMmSlIZN
   GbM5DzrkcN74pBeqpe24ZEu2c/Z3n3+X/PzXv6BT9uhVfQa+RCeGrJVjUkvlHK5fYkshDZpVEyu4
   z8GH8qUXf+j/xLmzd+Sb/+A3P+WSjdeSVGMUUx7RikaSMpjrYa1FCajCkGMZrJ/FZ7K0I5dsyXbC
   3vjD/5D/+dmP+MJPz6S1cgxaCpVkNE0DQQhAJZ4gIOMJlQR8gGu667n6dzdxwKv/Qh562IM49QXv
   v1MD2x0KaKqVktCEFRlOCgTBGSCxVCIopQHQonAtTWjopZ25ZHdpe93Z/yEzM9OkzrPb2CS7jS3j
   n4557m0CkZef+QH5xjnf5Ya5DYRJS9mCftVDo7BolFIEgaBAFIgKmEyjBSpXsdvkCvxAceZ3vsGj
   3vZ8+fG7TrnTgtodCmgiQpqmkKb0qwofPCKC1hrvHSAopWDJMVuyu7B99Eeflx9feC6XXn8l//G5
   T1H5inaSsqI1zvLWGK8+7Z3y0We/fadA5HVf+6ic9eP/4drZtYztvZJmljFf9aD2wAIBrTWCIow8
   DSH0+ygMeCExCeIcqbbcfY+73amf5R3q8hTFAO89VVXhqgpxjqIocK4ihFD/eIKE0X8v2ZLdlezv
   P/kW+fIPvsHvr/8jVRoY32OSyb2WY5bl9HPhhu4mvnfRuRz/4b+/1df62777Cfn+z89m9ewG2qsm
   aS8fRxINBDAKtEK0qj0zBcMfUYBBCkcrb+GLinU3ruFeBx7MKS9+75065LxDAS2EgIjgnIPgwWpE
   ImgppVCK2ksDhUKxFHIu2V3LLrzq91w7v45+HgjjFp9DYR1qWU7RVrjlGevp8rMrfscLT3/HrQK1
   Cy7/DddsugkznmPHc2aLDt2yh23nkBiwOoIaqj5vGqUMYLA6Q0vCeDZGIgmZSrjn/gfd6Z/nHYoQ
   QkApFUFMKaw1KB0vCZQgsvj7U9zBRdklW7Jdasd/6p/lhu5GernQzzzTbp5O6OEzYWN/mvW9KeZ0
   QTVm2Rg6nPu/F/GG735ih0DtWZ97jfz+2j8ySALJZIOQwCCUSKhwrgJdn6VATOkEMEGjvcIGjakU
   4/kYZadgbsM0973nYXzhH95/pz+Adyigee9jjgygBq/gPShqTy2C2uKfJVuyu4K99Yf/KZdefyVz
   qsC1DXZlCz2ZExqaHgV2PCNfOU6VgWsakpVjXLnuen78i3N36PV/fslvWNebwoxnSKbp+wJliJ5Z
   OYjnTRQE0B6s19igSYMm84aGZLRVAz9f4uZL7nvwof8nnusd66HVBYAhqIkI1GGo1hptdPx10c+S
   Ldldwf5w1R+5fv1qTDvHp4rZQYfe3BT9qodYKLrzqFTjqgHdoktj2RhiFTeuXb3d1377T/5Tpqt5
   9FhKe+UEIYH+3HR8TQUqy9Gi0AGMVyTekHpD01taPqHlExre4mYGTCZt7rXvPfiPZ7zp/0R4dIci
   xOJq5tAbU9aO/tx7F4sCNcgteWhLdlex9Rs2oKwha+Z4JWANtJqgQCcW02xS9AdgDChFmqbYJNmh
   1/7BBecgucE0E2Z7c3QHXXSrAYmFIOgAzSSnoTPSYGhKSl4ZivXzmFkPUwXF+g5ZZQjzJUfd54H/
   Z56rvXMuawm4luyubRpNKB2JMqTa0i/68TSmGa5fQIA0b1B6DyFgRaODoML2z8aamQ04IwQtKBUI
   tcOgUWg0BkNvvsd41mZ2Zg6rhcMOOoy977MHk/kY4gJpI+P6a69j0+oNHLjHvkuAtuPAJTf7vSyB
   2pLd5e1uK3fH/lHw8wXtVS28qShDSZJYKnExt1UprNdkNiP1ClMExrMm2wo633nBF+SDp/w7rNSI
   EmTROVJKjwDNuYpWu0lJl8P2vzc/e+VntxpS/uxDX/o/dFHcqT20m4PaUpVzye4a9qBD78fu7eX0
   1k4jswXLs3EySaCCNG3STJpIKaRiaZJSTnfJg+Ggu+2zzdddt2kdDofomlNGnZtGoUShVYQ0gqY/
   18cGyxH3vt9dyPO909rNPbYlW7K7jr3q4c9QR9zjUPI+zF2/AdMT8pCiK01KTqIytNOkwVLO9pm7
   aSN7T+zG0fc7cpuvOz21kdSaSIeqW5riMY88M0QjomhkTUIFqyZWcdLjX3mX8RTuYECrwUrJDoal
   Sx7akt117LgHPpQjDjqMvFSU0z1MqUhJcYWnKjyJTrHBEHoVE2mbIw97AG943D9s8xBMbViPHXLM
   iF6a1L8XNEEUwQtl4ahKRyNp3KWe6R1fFFBLHtiS/f9pL37EieoT535FWuePcdnaa9nU65GkTXqD
   Aosi0RaN5u67350HHXQYn33ue7Z7o89NT2GGrIHNzplGBLwExMP42ARpqsnT/C71TO/Y1ielCCOv
   ayHEFCQmNJXUgBd/1FL4uWR3MXvJw5+u/uohj2Lf9h7kczDeT5gYJEwUKc2+pjkw3H+/Q/j8DoAZ
   QK8YEIyOJ0UEBAwKLTG+EQQvgUFZMOj36czOLXlou8oqawha40MAEazReA1eHKJDndMM6BBQBAxL
   zelLdtezlx779BFYve8bn5c169fQbObcba89eflxJ6pr+eGtOlNF0ASl0ChMELRE+oZXIFojBpI0
   YX7dRo57wAO4fAnQdo0Juu54WqjGiBo6y0JQgpKhpzZsOluyJbvr2pue9LzblihWBl8XBCAGOLo+
   Nnp0tmL/tEhABb8Ucu6yN5co3hixKjafB+ItMoxEZSg6RxSgW7IlW7JtnCmv0F6Nzk5U01iEdwyV
   bBRaqfh3lgBt15gJoENkMMOwxKxAxzIzipHwXFDglzy0JVuybUc9XgjOg6ihiAZS657JUIZLpAa2
   +qgthZy7xlQIaB2TliN5oBFDQ49KzoKKBYQlD23JlmzbZ4oatKIG11BQY6QWNPTXJDggEO5iLIM7
   FJ+VxISlQaOVRoLUgDaMNxnNFRi50Eu2ZEu2dQ9NgzF6FG4GFaObMDpWkS0QvEOUEPRdq9B2x8oH
   BUEJGKUxyqCVjqXmOqdW6zyi6vyaWkK0JVuybVpIBLGLAW4osS21QyBoBSH4ePqTu9aZumMBrXZ3
   tVrgygzdMFUXDLQsVGr07QBonzjvy/KJ8768lKxbspF9/LyvyL/+H9kThXYEE0Zna3jAhqAWMS3K
   2mur6hkDd62Q+1bZO7/7CfnT9Vdz5XXX0HcFvbLPoCwIEqgfF0pgeXuCA/bel/sefB/e/biXbPF9
   Dn7tY+WmzgbG9lrO2tmNkBlMluJDBb7EaI1RCXnIKNbM8+jDH8a3X/rvtxnV3vzjT8rVq69n48w0
   a9evY2ZmhnJQxGTpsBtLadI0pdlo0cwajLfGuPtee/P5v33XrX7/k848WV761L9Vnzrny/JPx56o
   /vX80+SVD332Nl/nI9//gvzzY/7mz4LgH/jZqfL6hz1HAXzkF6fLPx/1jM3e50Pnf0Ve+9Cnq4+f
   8xWRbskrHvecW7WO137zY3LOb89jvuzR6XUpynKh4IMCL2iBPZavYvfJlawaX8bB++7POx7/0tv0
   eU/6yany0uPiWj/2i9PkVUdt/Rl/4tyvykse/rQt/v9v++Z/yvm//wXT/Vlm5mbp9Xt4CSitaeQ5
   eZqTKsshBx7M6S+6bQN4//3cr8nLHn786DX+7YIvyise8qz6M/y3vOqorY+w++hP/ltefdzC//+s
   r79Jfvyb8xlYoSMlXoVRTlorai00QTkhNxm2gkP2PZiH3udBfOiYF6v/rwDtJV98p1x65WXcuHEN
   s/0OPV8QNIjVmNRikwRdM5RVgKZNKeYGFLN99ly+J8c95Fg+/ezNVS/v/fYnyVXrrmVyzxVM9+cI
   VqESgw8eQlmHoil5SCnXzPOXhz+Mb7xs5wHt+I+/WC655gpmyy6VAUdAFGhjsMZgtImAFgStDcEH
   XOWpBgVVUWExrGhPsnJ8OQfstS8Pvu8DeM2xz9zuel74/lfLuRedT768hU8VnaqHN4IbcesErRRG
   abRS2JCg+5pjH/gw/usl794lG+293ztFvv3TH7B2bgMDXyA6hh+IoNAopRGl8EFQAcaTJvNrN3Hg
   Hnfn5584Y7treMeP/1N+9svzueyqP7KhM83Y3ZdTqGp00WldN0z7mFLIdILvl1A6UtE0dcIeK1Zx
   5AMeyEknvPVWf+bnf/jVcsGlvyaZbDBXdKmqCmstQcA5hwhYbcELrqg44r4P4Luv/9Rm7/P8z71L
   Lr/iCtbMrKOjelTGYxKLTWzc2yGgUBg0VjTdTbNIv+SAPffh2COP5iMnvv5WrfsFH3+n/Ox3v8Al
   noEf4KUi9s4ElBJ8CIg2TOZt7FzJPffcj69/4DQF8JYzPyZn/fg7dHXFgJLmZIM+FWun1qIm2ug8
   ZYFhVg8aChJJ6k5w/QrpV7TSFssbE9iep+EMh+57EPc74N60fUrqNa6o0KJppg0MGl9GaaMsTWk0
   GvgQ6Pa7LF+5gic88Ym7DBTPPPPMutlBNhN4XSz0aozZTPRVKbX9Kucbvvtvct6FP+eL3z2L2aKD
   aaXYZsbEylVUeMrg8RIoAFVzXrRAEIeZTEiaKZuKLmed+z3u/Ybj5eEPfzifftyrFEBlhTJUFK5E
   WxMDYAGtFF4WtzzFP9M72Zx+4kkvkd9ecSk/ufjnhNxi2zml8nijUVrjFJQhEIKLB1yDVQZtNEkz
   IZ/MSV2gGpRsKnrMbOpy0/RaLv7j/3LiSa+RL7/0w9tc2KEPOJzvXHg2ojPILD4zFFR4LaDjJ4yf
   DwzgBXrdDhdft+s43Of89gL+NHUDc75H0spIsiRKnYsa8ZIEhUdhvKI7KOn4gt332fYcxnf98D/l
   wkt/w398+XOsn5+iMdYgvds4nczhLGgdFYhF1VQcH1BBKEUwWUIiGbjAfL9gdup6rvvpGu71qkfK
   I+7zED71gh0fmbZ2foq13Sla48uZDT3SRoIxEnNIwQAKjyZUnkoJRXvhpd9+0aly3gUX8D+/+DGl
   d6impcoV3iq0AWcFkXrUog+YoJhotUlNk2JO+MPaP3Htt6/n6LeeIA898sF86Amv3aF1r+9McePs
   erLlTSQTkkZGkmiKQY+o/qOofGAuFIRynr0YjP7tjO+wsZqjamgKVdGvPLaZ0N5zBRMrVrBu/cbY
   6jQkDyhQakGWa7c9VqGCQryi6DvmfY9uCdNVhzIRWhNj5N5SDUp84UlMSqoTdKZQAt1Ol06nCwrK
   smJqatMu9bRmZmbQWmOMuYVMv4jgvSdNU7TWDAYDiqJgcnJy24B24udfK1/8zpnM9uZJV7ZYmU3E
   LzfRlKmiClB6oXK+VsVUcRFAvyhopjnj4xNkOmduwyyXr72GuXML/vqrb5IDDj6A0888HSxU4kYM
   5uEDR6m6fWOUcLvVfewvOfOd8rMLz+esc76D5JaVd9+TbKJFL5SkWqgIOO9xPhCGFVaJ71nMd8AY
   UpWR5w2SRkrStITCEwrHoPAUxRw//NW5HP7qJ8qjHvowPnrCljfyqx7zPPW497xA/nDDlQQdCKlG
   jEWMEJ+cLAC20igx6BVNNro5/uJ9fys/etPJt/nmu3LddciYZWJiN0gVvX4HJQqpLxCINJkgYJxC
   KuHAAw/grNf/21bf+xn//mr57Fmnsr4/Q5UIKw7YncmVk/RDydrOJoJViIq9gyJ+dFkZE5nqXgnO
   e5JMk7faGIHO/DxTm1Yz/fMfcPy/vlgecv8H87pjt8+eT8YajO+xksl9d8fPbYoKsEajzIJ0jkKj
   ncc2DYM0+i8v/+Wn5EvfPZMbVq/G5gnNsTEkUwRTUvmCoorpD5SgDBirMUoz67pMjLWZnFxFf6LB
   7Pppfnv9ZdzUWc8x736GnPfW07ffSD7oYMdylu29Gz3p4ZQjJJpKa0x9iL0P+GBQ7QzVTEf/tusL
   +jgak8vQKQyKLkU1oKj69MoCa7LYjL7o0NQ9AoCwcWoj1iQE0aQ6IZtsID3Put40l1/3J7K7aZbZ
   du2ceLTXaIlToQyayclJup0uebPBsmw507NTnP7lL8ozTnzWLvHSsiwbAdrNQQ3iCMwo1e/RWjMx
   McGJJ56otgpox3zwb+WnF/+STd1pGuMt9EQTpwIDXxLwDGZm41w/Y1BGx8MRhFDFOQAYoev7dDfO
   AykrJnZjrxX7MTczx7d/9F0O23Qf5oouupUjRuFcGAFKqMfaiVYEUYiom2sHbNfu87q/kjPO+S6F
   L1lxj72xzYxuNWDdpjVIqCDPYmJBG5SJYUUIAV85gnM0l40TvKNynvnBPKo0pElKkiXYNKE0nmUr
   l+Hm+1yx7jrWfG89f/Wv/yjffeWnt/iFfuctn1MHvPQ46boSMkOBpwqeCo/UXqjRug5nArphmR30
   +fWVv+cdP/qUvOMv/mmnN8oTT3ql/PQPF+LaBmM08525iF8hehsGjVF2RGIWZyimujzimAdy8VZe
   84GvOV5+/LvzcS3N8r32JFihomLd7Do6U5vQyybjWLSauSlxlBdGazRxZGF3vkMoClCGea1RAnkj
   Z+VBd6ecGfDjyy7i99f9iZee8UE56YTXbfPzz/U6dKo+DDps7M2QZimVcoQgo8sWUYjzEDxXrbuG
   +33mufLV757FmjVrSBsNvHH0yxmyNEe0iiEfIXK9jUEhOO+oXICyol/2yWxKblJad1tOqDwb+z02
   3HAFx7znefLU457Aq44+YavrNlmMACRTzM51GVRdslZGKQU6xDPlfMCTkCpBEjP6t2PLlqESSyE+
   er+pJdVR7TYUFTrPENg87CRe2gow1uAJOF/hNKTNHIxhthhw3cbV7L9qb9pJkzxNwYMPQhU8JqgY
   eoui3+ujteb4pz9FnfaFL8j01PQu8c5OPfVUGYJWCIGqqm5ZUBRBKUVZllRVxcTEBLAVYu1TP/lG
   OfuS8/BNRWv3FRS+ZN38NBiFzhOsTdDtVj1oufacRGqSvwIdwHqsNVSpp+xWzAzmSF2JWCFZ1uby
   a68EI6SNnKBjOi/IUHsj1FOdoxid1KznHYk43//dz8uX/uerXD29Gr0spT2+AjGK2aJHt+ohiSbJ
   x6mCr6+s2pUNEmkhdQ5t0O+iiHIrBEGCYoCnCCVKFI1WzqzromygfbflVN2Cc37/Cx7wnhPkCUc/
   hnce9/e3WO0+++7HZWuuou8qQq7wWhGUHgFafIDxd41WTt/NMzbZ4Ke//Nlt2iC/u/z3kBukoQkZ
   kaxEQAWFqqv3SgSjFF4g8Yply5Zz5OH35+biyx8754ty8hmnccP8Bqq2JVvZwjUUM/PTFGUPaxV2
   vBkr1D7KPSsg+ICEgIhDgEEoSJMEk+fxkYeAC56BOPrdaRrtFpUYbpjbxPcvPIfXfv3j8qEnv3yr
   O2BQFhSuJBUHqSFYIUjU0w8iNZ8xphMwivmqS++mq+l1eqiGxrYthavw3pHYDG00ykU9MbXwtaB1
   zHKpRopRGtGafnD0xaGswk7mNCcyfnn579ht2aptfi9ePL2ihy17lFKBFcgM2iSIB20sFo2uNBUF
   3UF/UfY7vrcToSxLgivJUkNiUrI8xZWxr0bJAn9zcQyU5RkOcMGDtgyUx6oI3lP9eTbNz7A8H6eR
   N9BOCGUgAEmdbyZAnucE7znzS1+RKlQ0GrtGW817T5ZlWxxfOUyPDD0zrTXNZpMnPelJaou0jb/7
   7PvlV5f8nj4enxpUM0c3G9hWE9tqgrWUzhEkDjv3pccVjlB4bNA0bcZ43qIa9OkPOvjgSBopOtH0
   qz4ljtbyMZxUqMzgVKD0FdpqlFHxrFkzGlU/JAbG+2X7iHbB737F2vkpQitB2hlzUrJmbor53jw6
   T2m023GjGIsxJoKYC0gVb59W1mJibJLcJjSzlLFWi7zdJGk1MHmCGCFIQS8MKI1nPvSZcV2S5U3G
   9lrO1Rtv5NSzTt/i2h7x8EcwPj7BfKdL6RwuhNicP1QXBSrn6VclU51p+qFANSxrpzfy4Z+evFO0
   geef/BbZOLsJSRWkmm6/A6kGFQh4BA/iUeLAO1RwKFfxyIcew6seeuItHvi3zv4+V6+/CddK8C3L
   tOuybnodRTEHNpDnhsl2E1sF7MCjOiWqU6J7FWYQSCohceC6A1y/pCpKnHOYNKE1PkbSyAnK0XUd
   WNmitfcKVnc28r1zf8SHf3CqbAsc0IoqeEQJhSuoXIH3JYJHdIgXrRF0ouiXPZxUtCdbNCeaqASy
   VorKDf1Bh36nixuUKCfoGHCQKE0jyxkfGyNJEoKCwhUUoaTQgSpVDBKhbwLJZJPfXXEprzrjI1td
   83CwtiAkaQJpgifg60lnlRfQlrTRJEkzFg89m5ubx/uA0gatLaCoCofrl2hf90hvwQcYzhkYFPEC
   0FmCziyFOAZ4ShWYL3v86dqrWb9pA4OqwKtQ91RHLpuq0b3VaqG1ptePQGuN4fP/fbJ8/Ztn7TTF
   5Stf+YpYa0fgtTjstNaOfpIkQWtNkiQ897kLld7NAO3VZ/67/PQ357O2s5H2inEqqZjtzlL4AmUV
   omvlC63R2mBMQprkpDaLgxeKiu5ch5mN04T5ARSC8oL4QNbIGF8+gU41M5vWY1o5OjG4skBchdIa
   YyxGx4WPSvxKL9ws25h48+Hzviz7v/BR8j8X/JB8zwkay8fpVgWdXpckz2gsmwSj6fd7FL0ernLg
   hMRr0kqh+x7XKSg7A8pegXKKUAQGnQGDTp9qUBBC9BxJLSKeSnkkAZVrnA3MVT06oU9oKI552VNu
   sdh3PPh56pC735Pl2TJUodFOY8RglMFqWyfmAQmYNKG9fJyNvRk2DGb4/oU/3akN8pMLf07IDfl4
   k9Z4C/pd8LH4oSWqmVCLmWgPSaVIS8V/PuvttwCzo97wNDn7V+cytv9uyESCGk8JVsAqsvYYk60x
   VCn0N3VYoVusCE2W+wbLXYM9GGffbBUHje3NvZbvx/7tPWkMDGG2IpMUvGJ2epbBYEC6bBnJymWU
   VZcuBTJmuWLtNXzjJ9/e6ue0WpNlKSAx5TH8UErQWqHr3JEXT0UgbTUoJVBWFcEFpPRkYmnbBm3d
   IC8145KzLGkzmbSxlaGYL+hsmmV2wxRKa7Q1qNSiMovODGLA+YpO0WVyzxVcvfoqzvvfX26dBGo1
   GIUTT6hD22G6RecpKMGVBb6qaob5opwhBis2ynSTMNmYZLwxjhdNpygIowEpw0r2wj8PGsRoQhBM
   UKRBYyshE4O1KS7AmvXrmZmfpwoBbRO0tSitCfUzGxSDCDg2gk2axRB3MBjQHxQ77Z1NTU3dIl82
   rHRWVUVRFPT7fUIIFEWBc27zZ7r4P7768++wXs9iV2aUMsAawZqASEHl+gQpUTqgtKCNwQ0KiqIk
   TTNa7THa7TZ5nmGVIU8m0ANL4lNaaRNflMzPzeBCAc0EHyqKsoAkAZtQDap6Ho3BzfdjDqHel1ob
   Em22WcH45jnfpN8qaBw4zgZmmOrOkGhDZlOkqKgGBc77mPfLU5QxKAd5CcvIWZWMsSJp0zA5mW2S
   6RatZIJWOk5mGmgSpArgwSQZOktiVVQHxEAlFWkzoT3RppeU/HrmDzzkLcffAtS+8XcfVgeO7ceY
   b5EWCU1JoV8hRRmJxVVJkuX4ThdXDEgmG8xmFRetvoyXfPv9t+rme8EX3yMbqg6hleITxczsNChF
   UnroDpjIm1RlFS8m0yQNGYM1XY6779G3eK3HnfQSuWjN5diDVlKs0MyYLl3p4qo+2gvjtkFWJYR5
   D7MBWTfgoObdeObRf811HzlH/emDP1aXvvs76jdv/pq66LVfUf/02L/h8Yc/ir2zPSg3FPSmCtAN
   yNuUTnDdPjhPqUqylU3SVRlXTl3NCR9/8RafwaDfRcSjVUDXIGa0IcOQesG6yMGKzcOaQgSdNVCk
   pCGjUWb0b5ije/UMyaZAtqlij9CiunGO/k1z5FXGRLaMlSvvBiZjUFQ48SijQAnBOaRy0ZsDuqFL
   sucYv73hMp73lXducc1eBZwVnAmxBUl89MJMBDqUYLxDuwKlPDZdyKGFgSetDGreM06bpA+u59Gt
   FmbZOAMd4oVbk2l1XV0WrSFJ0M0GOs1pSUq7r5noGMYGCS3botmawNic1WvWs279JgQNKoKZSSza
   apI0oTfo4VyFMorSOZIsoz0xgZfAl79664nIp512msCQZhOHjQ9DzsUglyQJWZZRliXPe97mBaMR
   Rjz5C2+Un1x8AdI2OOVAeYJ4RAVQgVFLZVAoNKk1ZM0xlBOq+QG93gCLYBVo52k12sx15+lPzzLI
   umRjTSbGmpR4ep25GFYmFmOTeHNWjrIoMEqTZA0khJFSwJAyt7WA8/EffqFccNmvMCuaNJePMdXv
   IFXMndjay/NBMMbgrYo5sUFFU+esTJtkXjPoFZRFQSGOoKBhEkrvMHlCu9nEJyCJopSKfqeDamR1
   ZlcTCBSuiOGJKEQF9MqMq2dv5EWnvlU++ZzNuWSPPuqRXPHVz9JcmeO8ww8c+ViOMgbnPRICSZLi
   ncMbhWoYusHx6z9deqs2yBU3XUtlIWnnFK4kBEeSpijvaOU5nbl5Ws024hSucOiucPiBh/LFF35w
   s/X+01feK9++6Kf4MUs2mdPxfUIo6iJOIDEJUnoG831SZ9hz2e784QM/UjfyS37EaVtc2+uOWQgT
   HvqhF8hvrr2cRDUYOE/V70d3kbj3SlUhaWBQVly94Xo+ev4p8uqHPn+zNYYQqJwbbWiptfQ0oIOq
   mfMaV4seGJPi+w7V8aTOkEnCZHMVu+2zO/vutTeTjQa9bpeNu80y3e9y+Q3XMN2fZdk+u9HO23Sq
   +SgIW4uTxmZJjcKAEvquTzqR0/eB6zeu2eIzEAVBBYIKm5e8hpSlITgrqcO+hb81mbVZkY6xZm6W
   qbk1KKmgbQi5o8xN/Pxa1c9h6ODVyjXDnObsPD1XMBlywsyAbuHweUooPL5MuXGmYixtM5mPsbw5
   HtM+IrFXVAJam1EE5UXwXmoXSbEzM8GLoqDdbo+S/dbGtNDQSxvmzIDNCgFbBLSLfvMrJIEkTyir
   CofU7RL1OKxaekSHGEb2pjahgyXDkgbNpG2yatky9r3bXuyxajeWT65gZmaG9Zs2cMPa1Vy79kbm
   56dIx5tMNifpFD20MnEv1NwvcR6vhTRNqYqyPjAyEuHYktrG+8/+rPzXV7+AaIWTEBN7WqESiwsB
   XSsOSIhN8ImyhOAZbzZJewE/38NVsPvECo645/6s2vfutMbHueGaa7jmmqtZs2k93ek+JRWqlaBz
   A5Ugxg/FpQgI3gcIIZKBtWZs2STF2lm+/YPv3ZLk+rjnqQe89TlyQ2cNHkej2RrRG8hyvPc0koRe
   rwfK0EhzfFFyyR8v47knv0H++2//ZbvJxL/5r7fIDy4+H51qmu0Gc+UcwTuy1FK6Ao2hcp68lUBQ
   uKJEdSuO/eujuZDNc4A/uegCNnZnaYw30UrR73TJ8gTnKkQb0iyl7Fd0ZufYe3wVD7z3ffkDP9rh
   jfzAAw/hmmuuxnU9aI+1FqcqJFW4EKiKgsxabGrYMDXF2T87dwslQ0tQGqWT2qMQRAW8Wxiwo0Rh
   RIEyhF7JsrSNNZ4w1+Me++zPuW87TV0FXLCFNT771LfL2ReeS3euz9hu4xRlt8YxIdS1RCHScJSC
   sqpot9v43HPtdddtk9k+bEcaViAXKJixuh9QUbRxkdbPR57+avXu750sVWZi76Y4bpxdy7d+dy4b
   +7M1JzSM1jV6L1EjcrCzOYfsfQ+Ou+9R7J6OIw5KHekZ+QBUr2Ks0eIfH3ui+u/vnCmD2S6VVNgk
   jcBWe00iUhd8Qq2zplEozjjjDDnhhBN2qDr/pS99STqdDq1Wi16vN6pwWmsRkZhnrfNozjn6/T7P
   f/7z1RYB7emfeo187fwfMrbPSoIJuMpFjseoslhXegSUE4wT9lx1N6Zv2kjmDUcdfgTfftG/qbXA
   /25lwS//nw/K+b+5kGvW30RnfobGeBOkriyJwySGkCZI8DjvRl9AkFh2Vwr8Fh7NL373a3QjYzxb
   zhwDOv0ezgg2zXBFhasb4CXUa0cwRWDj6ht5wAGH8IgHPYiPHv9GdeU2HvY/nPleOe/XF/DHG68m
   XdbiwHvsz3Xrb8LrBQHKyISMbHunBEcgH2+zfs1a/uYTr5MvvGRzr+f4x/41n/7qyUx3Ztl99z1Z
   P7eByle0xsbozs8TVOTZKGNAKbJmzvymTfzuih3z0i6+8lI6rodtJ/WdHHMplXeIUgyqkrTViqCm
   cvAlu02u5IOPfdlm63zJWR+SU3/wNZLJJi7x+LIkRZNj6IcKbzTaWEpfoFAcsM9+fOH5H71VFJOP
   P+U16rH/+iL57ZWXkhhhrNVkquiD1jjxlNWATCekzZzQDVx94/W3vJnzHF0kqKHXoGPBRdTwTlT1
   htfooCHA1LWr2W9sD/7q0U/gkye+ZZtrPu0571RvOPvT8pXvf40bb1xLY2ULpwJOeUoJdTmR0eWr
   tMJ5j00SpqdneOf3PiNvf+zmE5vUIoLYsEOFILXHF19P1LAwpm6hB/jWx/7tLdZ8rw+dIBvnNmBa
   Ca7Ox9YZdmTIsg0QCoeuhL1X7M7HHvmK7X5fz33cU9WnTztFAgptDGXpEB/PZWTk1LqGstCZMD8/
   f6u8syRJRhXM4e+HYFZV1cg78z4WTbaYlwS44to/YZsJTjl6ZReVKJwKoyKAjMJNwXiFraC7Zop9
   x3fnMUccw7df9G/bfSAff/zr1K/eeqZ6+CEPJO+Dnxsg/QorBqtiC4OyGqyhclW8Vxb5rUGBu9kX
   +uHzvySXXXc1fTyz/S4mT0kbOSiFr53roEBbizUGP6hw8wNMz/OQQ47gsUc+go8e/8btrv0zT32z
   esajn8wD9j8EmR0wdcM6cpI4lac+QDGENgSrcUqY6XUIqSVfMcFvr/zDLV7zrUc/Qx2630FoJ/Q6
   fcIoZImbYlAWmCS63FVVYbOUxrIxVs9t4vlfeNs2Hfo3ffsTsmZ+I6adIFboDbqRTqPAlSUmSdBJ
   grEJEhS9+S65Snn00Y+4ZYfBr3/BwAohN5TiER8Yz5v4foEflLjSUVaOoBTtsXEO3O+AnUoG3/uw
   Q/HeMxj06XbmUVLPlFACvsIrwRsgs0wPOrzh6x/dPEozBrSJdSOtGXIthsKG1N6JCQobFLYUGt5y
   2N3vsV0wG9q/PPIf1UMOfQATpokqPKoKsZVruJLhcF+tSPOM3qCPsbFtampqassemrBZwn4oxhD5
   cjFt4oFKBLcDa9SdEuvq10E2Y6HFuZyxVtKwORQB3d9xCe4sTSmrEuc9SkeJIi8BX5NcjTExIvIB
   5xzWWr7xjW9sN/j85je/KUmSkOf5CLiGZNqhpzYMPauqwnvPypUrtw5oM7058vEGA19QVn1Mqhee
   7KKnHblFsRLmpns8+kEP47S//5dbdRt/7UUnqcc/7NHYQpC+w6LJkozgAsG5uIkljCoz1B7alkLO
   y669irWzUxQq0HMlhXexrGwN4txoQxtjSG0KpSetYO+J3bjgtaep9z3m5Tu89rcd90J10TvPUA88
   +L501k2TBkOCxSgz2sSYGOq44PAKKiVky8dYPbuRd/3w87f4Yr//ypPU3iv3ZHrNhlgQMQm9Tq9u
   EYqbBsAFx8CXJGMNBjbwk4t+vs21/vDCc+iZChoxH9obdIEYDhMCKE2SZvS7PcRDOd9nj8lVfOqE
   zXttP3DeqXLdupvQzZQKP0pUl8UAFSTykUQoXYUoRdJoMNgCCXJHLJnIGVs5wcTKSUxqCHiC1CfT
   aryBTtWnUI5ONWD93OYkzriGuOE3q5Ax5BrWomBe0A56U/M8+uhH8u1//syt2r+n/c371H0OvDeh
   V+KKilD5uvo+TM3EvWCTJDa0G02W55Rbei6yyFO7mXem6h+R2jvTaltF/oXIuxJybbHbyDmLQGpT
   UpWQkew4Behpz1IiwqAs0Imt97vaTNJ7uO5QtyZt3Lhxh9qchjQM5xxJkox4ZkMCbZbFnPUQKJ+4
   lb5R+89nflBO+8nXcUpQSXywXlwNZqoGF5Ba+98GRRIUxxz1cD72lNfsFHv9iy/4kHrg254qV0+v
   ZtAvMUkWn7Lz6MTE0FJi3ms44UHULQHtihuupUoUNjWMjy1nrupQ9j2kJr6ATaD00YUlIcFwt+W7
   c+z9juIPfHOnDt6R974/162+kbluiaDRefSqRBYazVEKZTWSGEJQdKn4w7V/3OLrPejQI1j7iylC
   iM3PvnTY1BDSFOcc2hrSNKVf9HE6Ix9vcOP1G3jOf71RTn3h+2/x/N9z3uflg1/4BGHS4E1V5zUg
   uAqtwNsE5zxWWfAQyordJlfxkPs9iP/lrM0JuVdcgtMBkxgKX5I1Urwr6Q76NPKUNMmoxONFSJKU
   ysElV13Biae/VopeQVU6gg8oFduF4mxIwUkgazXolQMGvqA1OcYPLzqH9YPpSH1QVc33c/HQNC1a
   LL1ehyTJkFxz480S7S64+PlchdYQttBZoogN2rjAeNri8IMP3aldcLcVu/OrPzLie3lYNIVRwMfQ
   3qYpznsCeuRhbCl/tpiRISEqkQzBbDjsJF7o2z9uoXQkJsER6rYlGYFObBSIr9HvDaiKCm7l/bN8
   +XJ63ag+MvJK688tIbbwqUW5tRACZ555pjz1qU/d4uK/+tWvyjA0HYaSxphRr2YIAe89eZ7jnEMp
   xbOfvXUVFXvNjdcy8CX9ytNYNob3HlcNwNYgs9g1lojANijOeunHb1PP1n3ueShrfz3NbGcTWW7i
   7WQ1iTH4LRECuaVi7WzRozE5Tqfss2rlCtT8IOaLqgpsQmIsVagofUmqNZlJ2Ge3vfjkE9+002v/
   6PGvUce+73ly4VW/B5OhbBILGhLB1yiFMho3GKDHEqqyolCOK6+7aouvd7+DDuUP113JtXOrKV1J
   ai1KiB5UrwsaGs0mZa9LpQITKybpbZrlvIt/ycd+dpq86mGbf7kXXX4xfV2RNFMGYUCSaDISqqrE
   JpY0ySh7fbxYWo0xio09Drn3QXzmKbcMva++8Tq01VRVSWCAaiYoa1AqYSCeRFsIGqXApClBAlfc
   eD1/uvZaYKEqpbWp7ytPCJGcmTVz5rodAp60kWFSS0gCGEXeyCgqh8OB1qg0wWARAzq3ZGNNblp/
   88phwBgVgc3U3o6OvaPDwxw7PqKayKplK3n3sX+/U/vggLvvT6qSEdFUlOCGOTQv4D1lUdDKx6jm
   SooSTGK3GnLeHOREBFP32fqaYBqLc9vXLqucj9zAOoGx+Rmq5wyIRHZBkmHMrVPhP/FJT1GfPuVz
   IjVrwC5qGh/16loDxjAoCtI0ZW5u67M/5+fnSZJk5H0NvbTYlRF7NYdhZghh9He3GnJfdcN1NMfb
   5O0GZagiryRJMNqA8+Cjh5alKXmW0e/2ufc9732b2xtOfva7VDNroolqtUZpsiSh7PexOpaFlVbY
   NKXZbNJoNLCLPsyrf/RpufamG/FGkbabrN6wLrYzIWAthEBwFWhFnucYbZDSc/B+97jNaz/isPsx
   2ZrAYgmVR9fDXCkdYVAilScbG2emO0+3GrB8t5Ws3rB2i6/1xgc/XR13xNEMNs3TJKWdNAilw5UV
   SZ6jlGK+MwutBjQSNs5torVynC4F3z7n+7d4vXN/fT66lUKmMZnBiafyMS8xdCLTvEVuMqr5gsxp
   7n/QYVsmOXZnSDNLK89ifqOMtJbSCC7RdKsSLwGtDM75GGZnFj3ZIlnewE4m6HGLtDXSVugJi5lM
   MBMJoSG0VrVorWzHwkUikAhBO/pFF1evGaWQqqLT6ZBkKUVVoI1m49QG3v/zz8kCbaOg35tjYqyB
   L4sYWvtYGAghVqGVMRhjKQYlk+MTO/39W2WwOu5ZVXsW+NjfaJRGmwSlNP1+f9RkXZblLcFsUbhm
   ai/WaI3Vpq6YxwjJe18LB2xfLlvnGWXdaaDqghi1pxREUEZjkgQngk4SesWtJ8G2W60RuAxblLyP
   1WlrDM65ETi1Wi2yLOOMM87YYsBsjBm1TA1zZ0opGo0G8/PztFotJiYm6PV6FEXBM57xjG1eQtrh
   cUrqFmlG1TDxfkHff5Fkh1Gaifb4LunZajfbpEkalSZqLTBVc3sWPPhaD2nI9xmGGBJwMmzeqW/K
   IWetzr+Z+obylUcJtPImey7f7Tave+WylXEOQj2BoiakRw6d0lilKcoyVqW0iiFbNeBj552+xS/1
   4499ibrPvvdE5gsYOFppA6NM1CiTOq8yIhMFKuXQrZTLbryaN33n30av+YxTXy/T3RmW7bEcJ64u
   jMhmtACCQjlgEMi95bB9DuZjj37ZFjdJp98h+NgShffx8CUaSQ3BKnQWCwu+qih6PXr9PiGxmFaD
   vi/p+4KeL+iHAX0p6Iei/nVAISUDP6AMZWwf8gWVL3GuwjsXG9srYkjkwPg6xPND9WIY9HoLB0Mr
   EqvxvsIX/fozq5F8uywaxKO2yWrcgcT7qJqnRl7JZlFMTY3YQrpsB23Y6Bd5dIqFjo7t9kGOUjNq
   IT8ndUFgNEVtoaXQ78RjePbTTlRJkkSPd0iAHXppeqEyOcx/AczOzt4yn/61r8nN+zUXywQZYzYr
   CLRare1/N04k9hQuevLi4+02vCGHCx/yQlYuX7FLAG2sPUZi0ygwKHGjaLX5VpBaAcNXLq5r0Z8H
   CVGaZjiTa7MIREa3nvexkpPahDcfedtVYN/0sOeqBcChlh6KZeuhSCPejRqb0zShHAyYnd26GsGx
   hz+YMVKkX9FM8qhKUechagbnMLEYwSoRZkOPb5y3MFX7Zxf/ElIi/0ocEvwCv0kWJcW9oprtszxp
   8/D7Pnira+oXfXQcBz16f9ELBZDIv/MoNHnepNFok+dNekVJ2mgs/OQNsrxBludkjQZZo0GaRVmm
   NMvJ8wZ51oi/5g2aaZNmSGmHjIZLyFxCw6e0JKVJSlMlJF7hesXNWl6iXr5J0xGRdFGmahFMbKnL
   8VZ4aIvzYbWOnKor1HonZK6GOWJZNPQMNYSe2KKmWRgYvM0cmpZFuWY1Eu8cPYN6cLfUg7yD3rm2
   y3ajiYSwGT9MVAxnqzrXNaRWWGvx3vPlL2/ePdDtdkfgNQS/4e+HyX/nXHSkjOGZz9y+mKp2IdLv
   wqIbZwhq0WuqeT0h/lliE9rt9i4BNKNNTXtYKP+iFMbazT007xHnY0J3EWANgfbm6I4IUj9Uk8QH
   7ZyPRYZdZLGX1aC0Ga112LQbb6paw0kgNYbgHcVitYSb2cee+Ap1+AH3wpQBX5Qj73JRBhEkNpIL
   gZn+HON3W8m1s2t58plvkAee9FyZKuZYsfceTE9viuBfhxwjn0TilWy8ws+XHLzHfnzo8Vuu9L73
   56eI0ZCkUegyKs+GCGzeg3MQAlYbUpuQ2RSqQBhUlOunKWYHFLMDqrmCajb+uLkSNzvALf6z+if+
   d4mbq/AzFXnfknU0WUeTzkE6D0kX0r7C9sHNDhjMdBdARkfqj5dAkqV1Mn1hDOLoVzXCoduwbxdl
   p1SttVbrrY14ZTeDTLUNILvZt1xHG7UoSg1qKoSb7Ymte3eMujgXJqhv5iaKjCZA7eyJeOqTn6yM
   0pSDIoaK1hJEKL3DE1sjh/2Xw9BzsZ1++ukyBK2YMgijczx0noY5tE6nQ7PZ3MF0wAi9dc1Qrl3m
   2vvQRg+jUJTSaDTB7ZrRV8EHjDWIJoKZj1vPGEOlw2hDBudjBXQRIBmG4alsXv7eLE1cV3i0phyU
   BJXtMkATaua21YQayIbsDR8CKs0i07sq0d5jREYSNFuzRx15DFfd9Cdu2LCBbI9J0LIgmxSG2z3y
   65wvUM2EXiacd/lv2LhhPe3xFu2JNjNrpyMvTi0KgeoTYrAkWFY0xnngPe/LD7ayljcf/Xy1x0sf
   LGJjeOm9EMRHMBOBymPSnEae4/oVg/keVadg/7vth22toDc/j1l8mIcs+CFrXQ19Khkd4iBRSClV
   ikbPoUTRk5hSSAJY0VhlycSyasXdmUzGFjhSSY5ShsIFCuciL41hp0ut2KIWDrW+DXebraOWxaC2
   4AHWn3FxlmALyf9beGcsRLGBKCYZG+1riXYRzA70E+n6/YICr4fj69QIw0TCZq6gug3Du59x4tPV
   ySefLGVZxjPro1CrTZORxzVM8A+JsqeffroMm8qTJBnJaC8Gs5vnGKuqYkc7Dqw2NTmUUINDBC2l
   dVQTTSzaKKQKKBXLqZt2gFuyI9br9ePh1wloVZeCA3bIvK9zEcMNsfiGSo0lMQZX96dtHmIIyloq
   5xBt0NYQgkf0rvHQPnDe6fJvX/ls3CzWgPKxfai+TQOgjCEUHuMDoXRk1tLI8m2+7uuOfb568n+8
   SK7/1VpC5ZBh+bvu1JAQ4sY2YCfGmO7PIRnMqRIahlJ7Nk5tIEsSiuDRWo0ADRRaGRKVkAbLIQfe
   g/dtZyhJag1d8ThUlAtXjAacWJugvOCLElc4Gjpjz91W8OTjHsNHjvqH22XgxvmfWVDfCEEhKlbX
   xGuG+tObeT2Lc1my85dyTdRhqAYTk6hq1KokIqMc2nbBbCvV/DDMCw9Hz8mOgbCuVVRGNKdhfq+O
   vtSQGmJqeojctjPRajbp9nrRK67XnqQprnSkaTryvkIII3AqioKxsbERz2yYEhoCml7U4mWtZXx8
   x3P2OjJyzUhxluFAC3Sscg7Lp7WsSVVVrLlp9S7ZkFPT0/QHRezBHLKsiTylCAoLHfaLk/xDQLPa
   YOuwbjMXX+KN4F1Un02zHGUi6/g1p3/gNqPa6tWrGVQlTmr1AmMiX0prfJ1olZhcI9EGHQKtLGO8
   vf2k5tdf/Em179774EoXlUG1isz34S1dewhpntB3fWgmlAnoZW0qLXRnprFKjw6AHj09Hcm7ypDp
   lIceceR215LZhCq4mlRbe8YBsqBoBI0qojqqCkJuE1a1J283MLtFMjwQ29xsgsmyGmwid0vqS2EU
   bm4HZLZn6pb5h1rTjtF7cTN+mdoBMBv+pQAEowia0WRztYNepQ1EVdlhuLlogvrQ0x+NhRzmR2+D
   Pf3EE5XWOgpBpAkCVN6hjcZau6BYvCiMHDagD0PSoSLt8O8OPbMh72x7lc3NAU3HxPlo7mUdbiqt
   wfvaddSjhHzpHetnbvtAhH/5+WkyNT9Nv98dJZajpxjfK4oiSP1DLXm/8LkaGHLRWIm3ZdCC1yMt
   AYytE/MSaORRgbRwJVevvu42r/2G9TfEKT1U9X4Z3tSKoG30EuqNktgEqwzNtMnLd0AbH+Dwfe5F
   UoB1CiMGMAiaUPf1iYb57lz0DDIDvXkCgbyZYxrRC4ydToIoHVVxRWPE0vApYz7jvY/6x+2upWGa
   WG8xzqDEomOgDyh6/QFKxdxImiTMz8xx/TXXckeZNgk+EEPjURPy0E+SzSqHalho2VlAG+ZuWVCB
   XQySo7yYklEIusV3W6z3r+q/uQgF1eL/7WCxwUj8jJspPCsWVf9lodAgwq4IWtI0JbGWPM1QwKDX
   R8JCD+bQO1vM+g91QaEsyxFwjZyX+teba53t0D64z6GHse76G2nnDRppBnWvVtnvgTW40uHLijzN
   EQXpeJPrZ9bz5E++4jY9iv/86imopiIfb1CVA4xA6Psoehh0XSV0+FBiMoMkmkG1UNV686Oer+69
   175QVujEQKYJVRedKZCSshyQtxoQPPPTm2i1cwaUXL7hel7/rX/d6bW/6Tsfl9/+6WJsU6GMR+Ni
   iFz7kJgEkhyd5yCBrNFkdrbDPnvtu8PvccYLP64OXXUgMltBT8hsA6pAOjYe1UwNKBUAD4NedMPK
   gmowIMkyquBJjaGan2N85XIqpTBJjgxgrEj5h8c/e4fWceR9j8Z2LXkvYTK0CfMe7zWl1pjxFiGz
   FFWJRpEmKcoanvXlt94hA3kdYJMUIxoqQUkk/VpRmCAYCWiJKQGUbLGTYIdzaBLzslFJudZCKypU
   3Qal4xBMnCtBC2VwsIWBvsMK9kIOKUoEiQSoQFUa6y06GJTourl8O2Ar9Rg8zUglZxj5RNCNBQar
   Ynud2QXP/pnPfKbqd3v0Ol3GW2PUWpUjIFvcwjSUBhq2No2NRR3FYUU0z3O01iMhxxNPPPFWefz6
   oH33Z69Vu9OdniWUDpXmUcQtz9BZGosCRCVNj+AMuExx4eW/4zU//Ped2hVP+a9XyZz0cBmYhkV0
   zV6uZ2NKCIiKP+g4Hcjr+LPY9lu5J9VcD1V5bJJClqJCrMJ5V+HFozQEPFWoKIxnbX+aC6+6ZOfz
   Nn/8DRuqGQpdUUpBVQ0Iroq3qLJolURNLB9I8gbduQ7z03Pc88CDb9X7POSQIxhXTUwJxmmakyso
   +wVkGaWPrWl6WHWUsHAz13mXoihoLlvG7Pw82lgSlaCKwKF3P4hXPHzHEqz77bk/0g3QF3Kdk6fN
   mJPMUgZ1NcsYgzVxRkGv7HP12htv8wH5p5P/RV575q3bW178QuuM1iNqxmJPRRjSFXaOfzVa38Oe
   pYKqw8KhLPWw8qFvHmJuvaw6jIqGbdOLOBuj/FxQi3lj21/0kJKhN6shyaIUxJAnV1N5ZNdkCFat
   WoWEQDkoGNsBFsRirbNhDm0YZg4Bb2sN6NsEtHcd8wJ1wF770ts4ExnuSYYPw8BNCMFFtrkKkUzZ
   TLETDaZcl5/85nxe9j8fuVUb7+mff718/xfn0NEVLlNIbggJBANiI7/JSS1HXBdgnY6tJTffhIcf
   fG9aYvDTXWzf0VAZqTdYFTsKvBJUTQIttUe3Unra84cbr+Ko9/+N/MuFp+/w2l//08/Ioe9+ilxw
   9SWU7QQZS5HM4FWc56m9xziPKSp0ryB0C3Is1XyfVpLz8ee85VbtnI897fXqHnvug58v8N0SVQoM
   HEbbWLQZ8YsWKrqLK0Slq1DaUHX7jGVNBjPzjCc5xzzoqB1ew1se+Ww1MTZO5R0VAZUlYFRd1RXE
   O6QswVUYq/Dac/Xqa3niZ1+10+7PiR99jZz5nbM49X++wpP/41Xy/rM/u2Ov5aMgpDIKqZvo0XVj
   d93c7bXCaUWlFZXWO314P37BqeJt3JfeEMcRaiEY8DrUdAuFwcTRb0FHz/Hm4WHQmKDQQS2ke4bJ
   LgPOCM6Cs1BpqNT2CxmlAa8jSCa+HqPg65+gUEGhGXJCbhsfb7E94QlPUEDs6Ei23/A+9NyGdI3F
   6hpDqsfW+j+3XbAB7r3PgXHCTRGwKrbzjBpta9FEIcoEiwVJQbUsF19zGWee/W2OP/k12910r/zO
   v8p93vpk+dbPfkCVQ8g0lQ44HSJwGRWH7irZXBi8TraGLVwmL//Lv1H3P+gQkoHH9AO5pOhKYVSc
   5B6CIxA3mNMShySP5/S047LVV/GVH32Tvz/zX7a79ud964Nyxrnf4dLVV1NkQmNFOw4dsTEPokKI
   cxEqh6ocpgpkDnTfMZE2eegDjtypTXLs/R/CinQMWwj96Q42yaGK6qhKLXghN7/9BUWSNejO98iz
   Jk2dUk7Ncf+DD+XVR59wqzbJg494IHmW0e334wWRpQQCNrGI9xT9LkXRR1tIWimbetP84g+/5sVf
   evetArUP/+xUefR7/lbO+99fUDYDg5Zw4dUX85mvncoj3/NcedfZn5Ftl+shtRqtAt4VC17ZIrJq
   qGe9jig3Ox3exqhBhkn7OssutbJzzINpAou+oy14QkrU5h7ZsDdALWQwqKOTSJjd/iP19VyKUeJ/
   gXJW6/bFaVF+EdDvKpucnBxp/W/Xk7wZTWNYQBiG31tSo92hdADAfz79rWq/VzxKNpRdQikYk9Sl
   6OFcvxjGOe/xVFQYGu2UQdlndW8jP/nf89n/LX8leyzfjb1334t2a4wky5manWFqahOznVnOOPc7
   3LhhNWSKPffdm9lBl74vkaIEq7Em6iipELBaU0m8TYZdP6gtd3785dHHccWa69hY9pFCqMoAaV1W
   r6qYoLdxEnuFijMMMsgbDS658Y9cdvUVHPaOp8m973FPVixbgQRh4Bwbu7NM9+ZYu2EtZ/z02wyk
   IF/VxjYMjoqqKhblJYgj4YgscmssVgzldI+9V+zN11520k7tmvc97qXq+JNeKedf+Vuqsk9jPKfr
   HM47bFLLFinZrNw/StTmDZzvM9EYo5jqsEd7Bd960Udv9TpOe+G71OHvfJas3XgVpJZkMsf7gA5D
   Seg4fq4iQWUW74VN1Tyf/tZpPPBtJ8hRRxzJSU/a+kzN915wslx48a856esnM93vkK5qMD6+OzOD
   DpXVdMt51vzpYq6aWsOjP/IPctS9juDdj79lQcMAyjvEVTH/qu1mQd/wkKs6BlW3JdRSLHz3tWbt
   sF8gUjdUFP/U4LRCjMZvAT+9ZgQsTtevpusvUi1e8OKf7S9uSKYdzvUSGAF4IFZitVEEE73VXWVP
   eMIT1BlnnCGdTmck97M1G1Y8h7mzYbhZVRXGGI4//ni104AG8IB73ZefXnIRvYEnadqouKEFUyt+
   jhKXQz6PDrSWtVFBMeiXXLPxeq5Zex2Na1qkaUZ3MMCLIFWFTi0TyyZYtd+eFKFgpjeHyZK6xSpu
   PqVrra4QpX1DiFrwVZBttpO86hHPUX/5vhfK1I2XMT/dgVzTSDPKsNDnp5UiiOB8RSCgtaKPorlq
   HIrAVRuv45JrLwMv5M0WebtFqYW+KxDvIFGkTQs6MOgPcKHCWnOL2yYQcCisCGG+IBsIB+5+d357
   GzbJ1176r+qAV/6lzJY9BnM9ktwiuq4aDcfI1qd1KKeFgHPCWGuCan5AMTXPXz74Lzidc3ZqDffe
   /yBuGmxkYzGDH+iY16zDgrSRUBUFXdfD2hzTSkh0iskaXFNs5KYLf8j+b3ucTDTbTLTbpMYSvMcT
   6PS7fPKbX2DdzEacUbRWjFPmio6fpe97VDYnHU9IMkPXBH75p0u55A9Xcvx7XyFfe/PmoqISPL6q
   yAlkiaWoya26fj5RiWqYW5LNSNq31syQQlHzAn3N5NfoGtz0Qu5ODaMOtQXaxuZcs80ReEG1Vg8V
   YXegMquGhHOJTcZSewNBDeemR7D0OqZ0vGaX2gknnKBOOeWUHX64w2LB0LPz3u+0d7YZoJ31oo+p
   w9/2NLmpmKVXVTG5rgPaLE6uxuqO0ZrO/NxoPp5tJYw1lxFcbJcSrVGppZFlEISqLOjLgJwML47+
   /CyNZZNYpXBao7wn+LDgIrtAgkJ7RfBgjcJtoeF35KU9/FFMnVtw8Y1XAAlap2jXp2HSePtVPq5r
   eFdrKF1BkjYi+S8B8ujuamOpjEMnCW3TxJpYsarKAf1ul+BLrFU0bBJBMkRF+aiMqqkQTOXJ+477
   7ntPzriNMksA9zngXmz646/oFRU60SQ2Iaiw0N95s+4WhSJ4Ic8yptat4aDJvTn97z6w0+s4/W/e
   qY4//c1y9sU/Z3Z6BjuWxTfSChKD8zpeFjoQrEEZhU5TumVgZjCPDDy5nyEdJLiijGPI6lYq00hp
   7rMMnSf0yoKqPw1lRTY5SdHpM+hVpEmTsRVjFEGx9sYZrp1at+UbnyjfFAEnEIZkbAkoCViR+OdB
   sLcB0JKgMCFgJU4UD0owgYWiDAJGRkCl2DJNRNeV1/gjCxLbYUH+CB9l41WAdAe8ShtHj47oS8P9
   MXRG4l4xm1FZdrU1m83NyLJby6HdHNicc2RZxlOe8pSd3qub4fPBdzuAlY1JbAkNnZGblFRZjGjU
   UFWi1pTKGhkmMVTBMfAFAynphYKu7+OSQKVKSu3QTYttJlShol/00FrTaI9TFRVGaVJjES94F0FH
   KR1FAUXVFSBde2hbHzT8mmOeqY6+/5Hs1l5BKinFfIGUQoJFOQj9kuA81hiMjb2JOjHMDzpsnN9E
   Pwyw7YR0IoemwieByg/wvqQoenS784TgGGs3GR9rY7UhOI+rHK50EMBqG1VAayXQFfk4xz3w6F2y
   Qb7x8o+rlRPLGWuNUQ5KvA/1TatvRjZa4CylOkVV4Gb7HH7gbZd7+toz3qv2aS5Hdypyp2iYOPi2
   DCFqgVmNqjW/XNGnV/UpjEOaBmkZykwos4CMWezyBs3dx8l3G0O1LfNVl9m5TVRlF9oNmnvthigh
   zVKa42OkeUpRllTeseeee3L0Mcfc8oAYi0lSAkK/6C8K1eLBVkRQG7YQmdvSKVBXDSNJtd6bw6Em
   sogPFuJ76RC2+H6G+OemXpMKYMKCKspwwLFe9LN92oaq6yHxMw8r4WokMlB7fRJB2IRdD2hPf/rT
   twtIiwFtsYzSbZ2+vvlczn/8gDri4PvSWTdDQsJYawKDpd8ZEJyg0HgvtRRJrEiKVjhfRc2tzKDz
   hIF3YOsBF66M4+aBxCQ00px2owVeKLoDnAskSQbKUDgf9fHQFC6gbEpVecrKxVabbSRy/+2vXqYe
   c+QjmKSBzFe0kha+AvGKJGuilKUaFFRlhapJthiFzSxihYEf0HM9Ckq8qpBQQahQSkjS2G/acyXz
   1YBBcDit8UqTZDljrQnG8jGs09B16K7nT/9+tnrb41+8yxIU++27H0W/YPny5bESVJQ1EVlFmjyx
   cU9ClEnKdca6P17LMfc7itP/8SO7ZB3PffSTOOrA+9BfHSXIsyRHJym22QRt8UVJYhLyZhtVCwSI
   d3UAFnlZLlSj2a5lWeCKASrUunv9AXR6yKBC6v0RSkcaNLNrN5AUnsccfSwnHX/Llq0qBAoJeGuQ
   euoXBnw9VyJGmvEBxdGcO/9Ihg4UQxVeNBi78CMqdlQIhP4A3+tjtjDUI1UKKQooCprKkHhBDUpy
   dJSL1xblwShDYtMdYliEECcwWa0xatgDCgkKK2C8oMoK+gUtm5DLHdLYQVVV5Hk+ItgOh6TcFu/s
   FoAGcNqz3qL++uF/Scs0mNs0R39+QDNvk6dNEpNhTUpZeSoXqHx067EWlVj0SEIkkLXbsSm8XxAq
   TytvkuqEuak5Nty4jmbagqDRYmjkLZrNNo1mm2Z7nKzZIm2NoZIMm+ZYk9ZL3fZn/dwJr1OPf+Cx
   HDi5F26uoup7lDc0khbjrUnSrAUBim6PJEnR9eYPSnDK45THhwonDl03B7vg6FclfVdQGUU6OcHE
   XntRKLB5k8Q26E512finGyjXdzh0jwN52iP/epdvgBtW30TpYh9cTKiaKDGUZpBkI8UHrRS+9DAI
   tLJx7nePQ3fZGl531PPUkx7yFzz0Xvdn7sZNdNfP4Qee3DbJ8nG0yvBdx2C6i/Ixr6RqLbvgI0/M
   e4cPgc7MDKGMowoTZWgmOY28Ta4SpFfheo6x5gS2VExdt4YVuskJxz2Ok5/y2i1uAm0taaOJzZuo
   RgtfeyJh5KcNVWViC46xdqefgyhFEBU7EyROUwqiCVKDGwbxgtWWLEm3SmMwiaHRatDI81hQUprc
   JKTK0mq0SVSKVbZOl0C9Kbd9oI0hzfKYCgmC8zHEDr4e6OIF8bFve9DtURbFHQJoQ/JslmWjBvXn
   POc5txldt+jyfPPvP6D2mFiF73lcz5PpDLymKNyovQRjQVkwCcqkGJOCxEGrCkMx20V7RTNt0k7b
   hL5navVGdKU47F734TGPeDR7rdwLN/B05/r0pubpT83R7RUMKs9gUDLX7eNKjwRFcILeAV7zZ57x
   OvXsRz2ZzCWo0uD6QjFfUXYqcBqjc2zSxJUeV0U10KhuoNHGoLOEJEtr5QdQNpKMaTaQxDIIgdmy
   xLbHMWkOTqN6gXZocr897sEJRz6azzzpTbv02nvqp18rG6Y3YfM0klmHswpLFyWVRCGli9LdJk54
   d3MDDtpzP0562ht26Vpe/7AXqp+97nR18Kp9mdRjhNkKP1uRVpYWDdLSQi+QhFjpXdwcX7e34r2Q
   tsZotMZpZk2UU4S+h74QOp7Bph4T2SS6MKSF4dA978HTH/ZXnPzUrT/XYlBROaFfeMSBMRnKZqRJ
   gzRtkCY5xiZoY1GmHvCxsx6aNug0Q9kUNdz/OsWaDKMzjM2ofEC0QYyFNMUlt9y7mwZdusHRD55O
   UdArCgrn6fVLil5Fd65HOXCUhaeoPGEH1uwkROXmJIU0Q2U5Km2g0wY6ydBphs0aTK5YSdJsYZuN
   XQ5WZ5111nbj2NE0s3ovb2nmwm0qCtzcfvmaU9RTv/QWufBXv6TXLcgbCalN8TpQYGMbxlCqPQSk
   qtVRlSJTFo9CFzHxmScprtD0+8L+d9+bS176RXUJ8JDP/KPMrpumnU/gch9nRSYJpa8IjUZM3qJo
   qYy+65PsYGvXmx/5N+otP/mcXHT1Jfz20t+zaWqGtN2gPd4kmFgQ0MYiEvVu4+TqqKUVfNRlayRR
   MaAsKyQxaJsiRscG/kqR2ZTumk0wX3Kv3fflUcc9lE887Y3qwnd8dZdvkEuvvoJSedJWgyIUKKPB
   uejhqHTYZ4JJUhKdxMJFpXjIYUfwO776Z7lhL33/d9Uz//sN8uOLzmdq7TzZsonYwmI9MwOQEsRQ
   s/ZlxAfzdehVlgVGW6wodNBY0eQ2I20k0DCsu2maLBgO3Wt/nviwv+ANj3zBNoE5NzlJaUlKTUM3
   KXsuSnAP64ku/t57QQYOX94GCaygkEoIRdwrcZB1rKSLMgiBhJRQCj0/QDshbCG0s3kDk+RkeRMB
   kiQjSVOCD6Q6pSrqkW4Y5n1JcNvPd1mlwYMvQ6SOEFumFnJ88afoVfS7BVW163Noc3Nz26VtLFam
   raqKFStW/HkBDeDMZ75HPf/z75CLL7+E9fPTzBbzqIZl1W4r6JY9lDKxp43Ilg/O14MTDM1mTndm
   nvkN0wx0nz0mV3LowftxzEOO5lLOBGCsr3Gr58AlZHkSW69MQAWPzgxSebSLbmTW9eTFjj/89xwX
   D8Brvvcp+c0lF3P1TdcxtWYWpx3KKpLc4vGIChgLWAXW1kONowiiVglWK7SJfYGuCgQHNmi6mzay
   KhvnPoccxCPudxRve9QL/izJiKd+8rXyo4vPx7dVzDu5iiBRJdTXirTGWIKJnpCrPBSOu03uxSef
   +YY/a4LkS8/9F/Wqsz4qv7nsEq647hpm120gzXPajUZNPq3VQoyKk+FZ6FtMTBKLTC4OFXG9gl7R
   wemUZtbisN0P5n4HHsIpz32TOp8vbnctLdMgH2iSWU+WWLxJCeKxdRAYcJEhrxRel4Su3+nPnXjN
   snwcZUvKenZtWhfORHQcY5cbBkVJVTmatslY45ZUBAmGQbfAzPYR75HK4wclWhQSBrGlL80IoYJ+
   QFfb/zpTD26uz3hrJamKxB6tzMhbFqWRoCjmKzLJaNjWLt0TX/nKV6S3SBp9W4BmraUsS5RSWx1L
   t0sBDeCU571DAbzw5HfKBb//FVetvp4Ns32ak+14iGrNLu2G4n8OpQ1ee0ynZMKl3Gv/e/DXf/EY
   Xnfs89S5/PfotZdVGctdRjLrUH3B+zi2zRAQpxEPWaUY14rUtFim8lv9AT/82H9SAG/4xiflN3/4
   HTdtXEPP9QneU/oiDoZRHrFAojEmVlONigKNoQr4bp9qUCFVYDxvs6I1xt4H3IMj7nVfPvDEl6mz
   +cyfDTQuvvJSShNQWYZTcSqSkuj1DFOKUflX4QpHqAK5Vzz4Pkfwe77+Z8+FfOwpr1YAr/zSx+S3
   l13KuqlNdF0fPShwJoyS8qFuWIycPYUXD05IxJCIoREajLWb7LFid/Zcvienv+h96ne3Yh3jpkE6
   7/HTPcRASKP0kdSqIyEM5zwqXLdin4P34uc7+Zn/6dgT1f7Pe7hUtqRQLk468gYTFCHEqV9zro/z
   ASWWZnsFreqWR61RGcZCjpp3KO9JfD2vWplYYEFhfJyjmufjLMu23yM5phLGJaW4aQavh72gkXSm
   iN0LKEOoHBO2SaNMdul+KOpJTzsCaENJoV3lncFONHK975wvyB+vv5qLfv9rOkWPop5mMxxwomoi
   bDtt8ODDH8Ap//D+W/0eH/3Fl+TVRz3zz+ZdvPrLH5B10+uY7c+xcXYj050ZOlWXMjicqnllEudW
   ZsayojXB3sv34OC7H8Ann/mO260s9Henvku+9Yuz6aSeMJ7gbEDhCb5CfEWopwGZJEOLouqVNHXG
   Po3duPztX79DylcfOPfr8vs//p4/XvO/FL5HvyzolwMGvhwNs1EoGmnORHOclePL2X1iJXffbS/+
   9YTX3DEltzuB7co9/7Gff15edfTzbvdn+aUvfUmKoqDRaIw6ALbq5SYJ/X6fNE1vtaLGLgW0Jbv9
   7P5vP1Gum1lH11SElsYZj9KBUA5QVseZCi5gdEqmUlQR2G1sOfff+96c9bcfXvpul+x2tZNOOkna
   7TZ5nm8mlLAly7KMqakpli9ffpupGotNL30Nd0571IdfJGt6s/R9SbORkWuQQY9QdqPkkhXERPGA
   5a1xkn7ATJcc2NpzCcyW7Ha3U045RZIkYXx8fKSc4WuB2GHT+TDU9N4zPT3NxMTELgWzJUC7E9u1
   69cw7wao1MQWjeBJrEZbgw8VteQG7bEJqu4AW8DyZIyjD3vQ0sNbstvdRITx8XFEZMSVHLL/F4s7
   Di1NU572tKft8ot3CdDuhPa3n36brJ/eSBUcNksIKkqfY+K4MAQoHFZZcpNRdguqXsE99jmAd/7l
   Py55Z0t2h3hnjUaDsixH7P/NgEbrzSS28zz/s6xlCdDuZPaeb39Wfnnp7yDVmMyikjhNqhQfh8co
   BcqAFxKV4HolqgiMpy2OPfKYpQe4ZLerff3rX5eyLMnzHO89ZVnGAUU3a04femree5RSfxbvbAnQ
   7oT2y8svZvX8JtKxHIwsUErscORXnFdK2kA58L0KVQj3O+gw3vrIFyx5Z0t2u9piEu1wcLAxZrNw
   czjGrigKhjM8/1y2BGh3Inv32afIletvwDcNzniKUFL6CpVoTBpnl8bOaMhNRtUt0CVMpm2O3UXK
   Hku2ZLfGlFIkSUJVVaOJTt57kiQZFQZCiC2GQ2ntXUnTWAK0O7H97De/YEM5R9VQDKQi4KhwlMFH
   rSytQRtU0GgHqTfk3nDkoQ/gtQ9/zpJ3tmS3qw17NrXWo5maQ/7ZsEfTOTdSp7XWMjk5+Wdd0xKg
   3UnsQ+d/UX73pz8w63v0VYnXPrZjaah8FaWlUVidkGDRJUwkbVpknPXSf1sCsyW7Xe1b3/qW9Pv9
   0UzNoWc2GAyw1m6WMxsCXJZlPOlJT/qz7tUlQLuzbJCzv8dAV6STTZKxHJUo8GUk0JYlWbOFwuB6
   JdZpGmTMr5vmvrtQHmjJlmxHbXZ2djNBxqIoUEqRpulmwDb8CSH82SqbS4B2J7PXfe0jctWaa3Ep
   lFRxhJl4MDrOvEzTqGFVODKVkpMg3ZL9Vu3NQ+77wKUHuGS3u21JQntxd8BivbNhHm1nB58sAdr/
   Mfv5xRexoTdDNt7A66gAggRMkqAkSsK4QQWV0DI5mTeorufwexzC6x/5vKVwc8luVzv55JNlMVF2
   MZgNfzXGEEIYUTi2Jye0BGh3EXvzjz4p12y8ieaKcZJWShCHq4ooeqcMrnT40hEKT6YSMjH4+QF7
   jK3gQYfcb+kBLtkdYouJskNAu7mHlqbpKBTd1S1OS4B2J7Uf/uJcpqsuzRVjdIseuBKci/LVQ/US
   DymadtpEehXVbJ8jD7sfr3jYM5e8syW7Xe3zn/+87MhkdOccaZrS7XZpt9u32/qWAO0OtJd+8yPy
   +6sux6WKEk9v0AOlSK1BK4WEQKItqUniBC4MrjNg1dhyPvvC9y6B2ZLdrnbGGWdIURSjcHJxw/nN
   ezWdczgXhUif+tSn3m57dQnQ7kD7+UUX4iw0l43TGfTQVpNYjdWK1Bh8FVVWo6yyEApHguXoBx21
   9PCW7Ha3Xq9HmqYjjtnNAW34+2HI2ev1+Lu/+7vb9eJdArQ7yN79nf+Sqy+/klWtZezeWo7uOJap
   Js3Souc9YyEnGyialaFRGGzHo+cqJnWTk1/wniXvbMluVzvrrLNkOHpuOKVpsd3cQxsKON7eZpe+
   qjvGzjzli+xlJyg2Ofoz65hQijAziINhUSSJI+8FrC7ITEJnU5fE5PzV4x/HZZ/8wdIDXLLb1aam
   poDIN5ufn2d7ebSiKHjxi198u1+8Szf9HWQf/OKnxOlApQJeC14LQcWBG6KiflQ5KElNQjtrYjzk
   OuFVT1xqQF+yJdua/b8BAIBeN85N8e7HAAAAAElFTkSuQmCC" transform="matrix(0.3382 0 0 0.3921 26.2286 27.2952)">
               </image>
           </g>
       </g>
       <g>
           <defs>
               <rect id="SVGID_7_" y="25.3" width="612" height="791.7"/>
           </defs>
           <clipPath id="SVGID_8_">
               <use xlinkHref="#SVGID_7_"  overflow="visible"/>
           </clipPath>
           <g clip-path="url(#SVGID_8_)">
               <text transform="matrix(0.8627 0 0 1 52.6323 76.4106)" font-family="'ArialMT'" font-size="12.6673">RC: 16881089</text>
           </g>
       </g>
   </g>
   <image overflow="visible" enable-background="new    " width="122" height="75" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAABLCAYAAAC/f5PsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA
   GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAMN1JREFUeNrsfQd8FNX2/8zsbO+b
   Te+9k0pIIEAooQhSFLBh94HdB1b0vT/B8gREUJ+AgAIiohRBqvQ0COmNhPS6m2yyvfeZ+d/ZTQAR
   FdDn8/nL8RPZ7M7O3Lnfe875njI3EDQiIzIiIzIi/2MCj0zBn1sIgiAxQsAPDsMwMQL0Xwtc5KVV
   qwL6OmUTVBrdFLPZJOTxeK3Bod7fTM/MrF+0aBE2AvT/qOw6dYp9/vtTiXKValK/bHCyzmgJwDCM
   a8cgGEFgCMZxiIrCjqgw/7fGJsXuzcvLc97O+SkjU/zfk+L6eiGFypuOsgVLT50493J3b/+DfQOq
   CWaLzdPpJOg4AUAGVhuYbFLNIRyHKSajKYPN416qryrvv51roSPT/cf52jVr1vCkJntQd1vHJJlc
   lfPEU39PNJlsLBy4YQpMmleCxBMAC1wy0F4GivT5e4rr+HyepLlLsshstniZbU6+ZEB5Hzhl5Yjp
   /hOB++qqVZ4d7dIkpVozQ6MzjDGY7cE2uxMhTSkCUCUgDLAsCqm1BJWKGjhMqiQqPKjIz8+7W6c2
   BnZJekaD4zmjEuMunDxbvJQAuukl4iqPf/t5lr+/v3lEo/9LkkfkIZY1jNi6mpbsrOn3TleqVFEW
   O8GHMCdQU9ztLwGwBKm/FArEYjBU3l7C6sS4mBrwKyqXK8Ja23vurmpoE9EQ2MZksaRKlS5+9iy/
   w1SUCjAn6Eq1Vrxx554IcKr6EaD/INm3bx/tfF2dp05pSFQpVdnHJlfmygaV/jAFAfyJ4jbHAGDS
   zUIUOk6loDpPEW/Q31fUHJ8QK9HrjEhXT+/E/KKKcRa7w0GjYAMCPid/THJ0/jOPPHiRGxWF33f3
   A5WSXlmaSMjtHVDoIklq1Xi5edrtAD1iuu9AjlRWsvbv+CoRAJqlVmlGmU22MQaTSUCGuzBgyLhL
   cQnX5FJpqFPA5av8A7y6QgP8lDQ6XSsdkIn7pAMRCpU2CMMcejaDXUulUy4FBXjVvfj4wzWTJk2y
   Xn+98bPmb42KiAgxGExNF8tqF5DmW+zBrvy48MS9k2DYOQL07+hrdxw+HHDy6OnkXkl/htnmyLSY
   zKFmi51JXDeNXmKRC2KTxQRFhgaqY6MjVF6eYo3RbEJaWtp5HZ29vlq9kcPhstupCFIh4gsuRcYH
   13z67rt98C8AtufIkew+ycBK+eDgkW+/P7kcx2AaSoW1j8+bNTMv743eEdP9G5MWR86c8dmxY3/W
   5Dn3TxuQK1NTk0Z59EoVdDLoAUyKDHCB23VrLpvDwCLDA53Zmel6X19fW1d3N+1iaYXfyTMF4SaL
   1clm0lp4PM43ORPHnOLxWe1zJk7UA811nv4egja+994vjiUkLOzKv9ZuDJ46cRwdoaBqGHP4AD7H
   71EMpoCPe0c0+jaksrKSunXrMb7SPhhh1BnGm8zWXMmAItbpdCK4K+FAAoqDBYBABHC4fD4H8xIJ
   8bjoSEdmRirGFwrhmuo69HxBEbW7r9+JUigKLpN52ctHVPTIw0+cfHj+NMVvSWHGZ03Z5+npgWJO
   SNvd3TfdAcYQFeJ9rPDYgWfAefERoH8F3O0HDgT3dg9kyFXaLIeTSFWqtMEYhsEkQyaJFOlryaQF
   hKCQUMjHkuIi8KTEeJzJZDiBSXY2t3QxK2vqUbPFpKfT6K0cJr3SU+RRNGt+bsMzDz6o/S3gXi8T
   Zy58Rq7RPJOaFLOt6FL9MhzD6Fweq2/enPnTV694VjNium9kyfn5nEO7Dqb1DUhHP7fi7TFqjTHK
   YrN74GTWwgUuufrBf2TiAsQ7MZGh9rjocGtERBhEQalEb4+EebrwItrT00uFMaeMSqcX8TnsspiI
   gMqpWWkdS5cudcW2xw/shJ596KHfbdxib2F+V//gq2KRp5k03wTm9DWa7N4qbU8s+LhkBGggZ8vK
   PL75+mBuS2vX+FVvrR5ltli9HU6MRQBWg7n0lYTW/X8ajUKkpSQ6J08Y6/T29sKuNLUil5va6RfK
   v0eVCjks5DPbuTz+mZjIsAJvFq/V74HZ2jzga8nr7N/5n7uHxBC/3pqGNklzW2uskMfqVCptvk4M
   Q3vbJFMAnyj9NfP9lzTdz7zxhtBuh0KkfX0TVQrtNJ3BGG0xWxmkl42LjjDFxUaZjp0872m12mAq
   jUr4eAqwrIw0W2xMtNXDQ4BUVtayKoG/BSwZB4RLxeexGzks+qnUpKSLG96HemE4D/+j74lk/mOn
   z33PYrVPCQsKOFZW3fQ0iZ6XmNf6yLxp85ctW6b9y2s0yZBXrV3r09TSkyAbkM/NP1+RbLPbA+wY
   hBK4i0K59BYBr6g0CkWtUnDTk2Lw9PQ0LCw4AFOqNERh8SU0v+iS0KDT2VEqrY3P45bExYWejogO
   a9qwcqWO9LVFPxyCPlp968CQHO6SVEr1DXASIVCI/VZI089qJLj+jAWLT/fLJYuiYyJ7K+qanQSO
   o2qtKbi8sTsIHPLXBBpMJPrKqvejWlrbJmdNm5crV6mjbQ6IjWE4QoHdxsrFggCPouAY5Ocjxken
   JmHjx43BgT9GrjS3Yj+cOYdKpDIqMOEaLotVI/IQnE+MCitkBogHt6xcaRkmUh/l5d3ymF59a1VM
   m0SSO3XufRlqrTHQYLYwqICo8wQ87V0LFl9ISk3e+/6brzTfyT1njkurbWrpMra1d/uwGbQuk9kS
   aXPidJ1eN/bXsmT/U6a7ra2N/tnXe0dXV9TO1BjN6Vq9MdDphHmkr4WG9BYeSjrCEAaFhwY6p+RM
   MCTEx2ADA4OMxuZ2Wn3jFYoC+Fow91Iul3uJzWKcE6LUhuBgb/mGDRssd7Dg6K/+c9W4iuqG6Vq9
   IcVkdgTaMYyLgYENTzExPNEUCsFioMpQf+8v//XW8k/T09Mdt2u+UyZM28dhsdk4hF+W9KsWO3AE
   igzxKSk6tm/RLzH8PzXQJ06coJ8sr/eW9/VO7u6W5qi0xnQQ3wpxYIgQV4EAhxDSQoKYkkKlEBwG
   xZGQGG9OGZWoDw0KoPb0yVj5xeWcltZ2gnBa9UwGo8PLU3TW24tb/OiCBc133XWX7XYnen9BAbvm
   UrVfZ2f3lJ7e3myt1pikN1mFsCvSJrsECHftAoGHaxjuaR56nwDHIYgDDwvw37v+xBsr0uHbA3vu
   g48+wuXyxT5iQdueQ2c3wzACM2iI/YPVb425Z/p0+f+M6d709dfCyrLqeJlcM+n19z4ab7bawq1W
   h4tIwe4UMkQBrg4lgeWwcRFfYB+dlqRLHhVnwnCCVl5VKzx8/LQv0GCyriDn8rlnI4O8z4WGeFdu
   Xr9+AKx6VxvO3u3bb1dzKU+99Nqy2vrGORqdIchud1LdOTHExdiH0HVZFYgEHCdcoEKukgbgB8B9
   uO+AbCBAkS7pwKLX7/mwH5z3E/gW89WkjElNrFTpLbnBQb5qFoupsFosXjY7Tvtmz/eZZBr+T6/R
   f3/zTd+yyuaVaq0mHXM4RVY7RieGoloMcf+LgMnjcZl48qhY2/zZM20CPtdad/kK60JpGbWlvYtu
   s1oxFoNex2Uzi/x9/fP9w33bP8nLM9xu0oIEdeO2beHFJdWp3n5egx+/t6qAfH/hE898COFwPE/A
   7im8UDWFXIDXvoUP5c4QiEmDMBRB7Wabg0yXIgQOuT6BrroVyPUvn8tUz82d8Njqd/5f1e2MLTV7
   +l4fPy/5oELDG1ToJpHvx0T4HTh3eN9LfxqNJrNRn331lUitM4UqFNpMBEZFPD7PdvJ82SK9wSJ2
   NzxCQ1oCQywWFffx9rSDuNU4ZnSqhclkonX1jcIPP/6Us3D+XOSr3Xt1MBW9HOTrfXrRXZOK/va3
   vw1ef71/r1r1q2P6BLiIK2cuig0GfWC/fHBCZu68mTK5IgLDYCTQz/M8OKSInGNfD/GJUwXFCyw2
   RzxGVh4R5Drz7DY3Ii5dtfHT1ZNz0tL0jz37UmJ59ZW3wX0lu+uUQ/VoCuHACAqiM1hF5fWNzwHw
   nrzVxUhapOwZ80taO6UPZqXFfzaorM0BHgWWDqqyLjQ3c7NjYgz/NaBJNpqXt9an9HL9hGdee3u0
   w4mN0ej0gQ4nYBIkpOD/BO42zmASCE+x0BkRFm5OSozFvDw9YJVai9TUN7A/+vc2kdlmMzEYjBoO
   k1VSUlp2+e3Xn6uYP3++K7Q4c2jPbfn/gpKqkMttXWO+Xr91jM1hz9Bo9b4OJ5nJJnu0gM8Fc6/W
   GSK+PXLE+/45cwZyZ02pPXG20AGCNDoFIUeMIzg0VL9y+WQY0ulNovMnzvpOSk9Xgrernvn7Gy+c
   Lrq432rDfchFjMAEnhAdulEqU09QafSpkv7B7EuNl4TgWPWtjj0pKeFU/5niZxlMlp1CoRgwB86z
   We0eX2/bGUVe8w8FurKvj7V65TsZ8gFFZsbUuUlmiyNcb9D7ATN2dekCowbhQDUoCAUKDg6yjk5P
   sQYGemMOm5MC4mHobH4xTyKRIoAidzLo9Fo+j3UxzDOgLic1oXf58uUuhnxo9+d3NL6te/bf09Tc
   80+TxcbHh7Rx2JO5eDLsNrJ2u8O7oKh0LAD64N05OZpPwwI+NFsxjcNuz5DIlItgF78H94APk2wE
   vtLekwsWdwOppZs2vN81fsa87Z1S5Zsu8giWfUxspL5LWuxHXtNksrM//2xv9i/51xvl09VvN8cW
   TAHhvz6Bw6R3ap3mZCcIs3p6+yf+IUDn5+cLtn67P1Mh1018dOFj2War08fusDMBMYHJLDKMQEPm
   i4BQFCUiIyKs4zNTnUmjEiGtVocXlZQyCgsLqCBsIqhUpozHoh5JSojONxjMl7NGRQzm5bkzUkd2
   //axDgwq2GarmUcW8W8kKsM1ZjIGYzKpEpvZSht2xKe+27OZBHD6/YulfXLlfAKDqMjVDLl7schV
   yondUPcm8IuVPPbpv79xXKYse8ZitQsxAqccOpq/AiyUITIHQR0dvcm3AzRpvpMnTK/s7pGkeXt5
   XNQZjUlgiuEBuXxiiUSyeWxgoOV3A5oMNdat+4pVXpsfrLc5xhiNlglPv/b2RKPZTne1zlz1X24a
   QqehDg6bbQgLCzamJsXbIyPCsY6ObnFJaTl/1zf7nZiT0HG4vAqxkFs+eVzW+TXv/KOFzCSVDV3v
   1MFbG9Patds5jW31oTqTPs3X07fis0/+1XCzY0PDghvlCq3V5iCYQ89B/OQYNp1i3LHhvbszMzP1
   Ozdv+NFnWTERTa3NPVo7gXvCpAe6ziL0y+QRez45QvZ0ua79/FOL+y9VVl+0WB2zYTDldjtOJQuf
   LlIGVAA47ODbnX8fH7+jLW2d09OT4rZ0dktN4BwcnckS8/maf8dDN+kQRW8X3FVrPg5sam2Pz5q5
   cIzFbM0ymUzRVquN6tYEdwCBgZsgs1FMBs3o4+PTHx0eKPXzD0BByEtIpbKI02fyA3fu/gajUhnt
   wN8e8RQLyiZkpdWsycsjOy2IgmP7oLXv/vOW058rVm0Iae/pSBw38950k8U+Vq83hNuAxgT6a8pL
   SkoeHDt27E9W+JL7F1zu6uy94sAp3gql2osMzaAhZjwswN1wdx86Mg68/OHG769cuVJ9vLiytk+u
   yb0xfLE5ce65/AspYGyN5P3Ex8c7GEzGFUhjme1OyGJDoZi7XgaufdsKhxJYAzi/HccRMZPO6HeY
   rVEms40j6ZekgferbiR3v3oBMhu1ff/+8NbW3syPt36Z/t3R4+l6g9nPgcHwsLEafg4AnBvn89gy
   D5GoNSM9UU+n0ygqlc67vasnprzqsrfNblVTUWodm82oSIiKLEuNSW3Jy3vBFf6Unj4Grb0FhkxK
   H/D/a7dti2ioaxs/dsbCDJ1eH28wmX1coepVzUJIzRq9ede3c8Ev3954jkmTJhnfXb/+bTqG2Hcd
   PvmWSmPORq6abXf4Q56nrqF98s2AJq1N7rz7z/UpjTmAaFCv/wwHlNpqdpB+9xvw43SZ+nsXSyX9
   SlewfQ3mocibgupvF+j0+DBFt6T/cmtXZ7bIg99qMFuiyO5SjcaQUVBQ8CXpNn4VaJIlL/9n3uSq
   uqbceY8+k2K22AKdGM5ubO0m9DoL4sr6kOsSOCgUjFQo4LYH+/uXjclMlapVCjTIP4S6a+93D4IF
   IaRRiH4mm5fvKxYV02jOar/4eM1wHvkotBNaterFW765R55+IaWrd2Bx7sIn0s0Wi6+71AjBwxpF
   3JAccOAoXFXf9NK769Zd+scrr/TceL5/LF9eSVqpw/mFZSqNIZu4+k33mQhAElUabaqEkDAD4Z/6
   vbTkpOK27n6NA8K9rtdpUgG0RnPi2k8/9SItuXtOEVIrYAJ2j5RBhR12B0YlkWfT0NbbBRrwFXvO
   3Qvy5XLNS2mJMRt7e/tn44BUWGz2tL1HznqQ+vCzQC9ZskTc3K9+Onbs9IUmvVGMu9J6bi9LrnC9
   Tg+jFIotPMRfBm5mMCUlvs1H7KlvauuIbenoGv/5lwcCKQis8fe63Okh5H+ZkTbq1JTHH2pflJBg
   v3qR/fuhrbdYJLhR+geUkcAf3Q/BqFvjkGs8+XqAXTlvoDdkDxAIdwLzL1a/CAB99WbVI3LBPf7i
   8tK+fqXd4SBo19s7H0+exUcs5v9r+aZ08Gvxjd99f+UbvSfPFTcp1DqvG+mc3mgJqK5vSSKHTS6m
   Kfc+HI/DqKujm06FnfNmT9lzOr80V6vTe0+eln3m7NG9tz0fnnz+uY4u2WswnWZkMhC9yQHztDqT
   p8aoTflZoMn+5I1f7X+vs1syy0mQRoA0ZE5XLhmholYmg94SFerXGBwcKM3OGqOhADf83tpNr+sM
   ZjqK4DIuh1U1Kj7qnRB/4eVP1qzpJyf1LDjDlg/fv61kSqdGwzJKNLTpjy80gfjDcr2vodJpVTQG
   TW+34Twy+PbzFqqio8IbCoorJpLJZBhYGIIgUxO4i1y5/gWa1N3bP+fh55afAac4ebPrjgpNvKJQ
   6o7VN7bPxZwYBRriGsDn0Tp7e73BGKbeDGjyHifedW8pAHoiMZTqpICL0lAERGVORp9UNg5EImeW
   /2NVam+PdKE7ewZmFZiaM/kl94BFyPb0FNaveP75tjdfeOG2gb5rymJpTfOqXrVSnS0UipsMA6ox
   IAQACmkcDz4+dtMU6ILFT+WU1zfvwkh7BeaHSYcHuRx2dXhIYF14WKiuq6cnsbtHOlqt1fn5+/s5
   n3r0vuKt23e1M+mcH8YmZXeuXLnEcgepRuT99RsjKmvrxoKQJMVgsKTqDCY2+IhGp1LNAQE+5+/K
   Ttv48ssvS8jj1+/bx9zxyedfA386xlUeoMB4WJC/vKVT6sNhM/ppCGbVGh1h8A0BEwmCl1hQOWNG
   9mOrV6y4aX9V1pQ5/+wdUD39Y1pFuIonnmJh866Na2cmXG+ZhuRfH34YtWnHd+cAfSbTPlDW6IQq
   ENOyWGy2vru7R8gXcEtb23vmWKyYgHQNLAaF7PfV6QxGHy6T1p6ZNWrF1nXryu40+smcPv9dk9k8
   Pzsz/cDhEwVPkWbO04Pb9/WmtdnXj/eqRis0+rF2J04hsxNiAbM9Kyt5W1tr14SWtvaFNfWN5JMH
   diGfWxoc4LstMMi3nkMRSIqOH3QV5E8f+gr4jKW3Ci71nfX/TiguvjQ5ddLc8UajORQsfwGIr37k
   RhwOm7CptfthhVwx7u//eGfJR+/+s2nZwoXW898dP0qlyBV8Ae9i/4DqjfYuqQ8E7A8NIdjRESGb
   y2ta3gamHb7msd3QqTW6lNaWrpng5U3TZywu9TKsAG4dI6jDC8XNihFIozcG7D5wNAD82nnj91Ys
   X96x/ZsjErPFGUxOclV9ZxICO2C+QKRRqLSinn5VlBPHIWSIRXh7eZrj4mMUhUWXPDLTkt/Zum7t
   HYNMCo/FKJTJ5PeHh4VYaBTYZsVcj+z4fnv8eCj4uOUnQJutFvpw95S/n7espaXnIUmf3NtTwDoc
   EuJX/PCSJ8oXAaY6fPzOTzfc0kD27Sth7j65R8ihIsk9PdI5o8bPJOvIgCG7A1fC9ewvcq1R4Cpr
   dptepdYaVnSxfDMwgbPBoiKvv4P8If3eqHEznwB6zSe1zuZ0cv2DfEs8uvqKVDrLRAK6FhO4sswY
   Tmlu6X5zy5dfXlj66KM/6YWenDPjUlfvlyorBvlAQ6UHeCjvbndi7K5eSfaNQANCxFr6yptBfDbX
   arHoXMbb7LAATwZD5gGF2FWavJq1J1y31t0r85LJBmgR4YFvP/DxmuKtn6z9TYmfR/72cNmq/7da
   3tPTFy4QCJQKlcafXJ1XGtunXQ80MvyCwaA3kRU8AvhlsPqjE+JjWmg0qmX25KmfH/3mq/PXg3yr
   8vjzyx7/YPN737bW1Z8pulC1rVsyeLdaY/DFMZJ6An9GcXtS4oZCGgwNw+R+dgn4z/BdB4/dPdSe
   cy2MIfCrTBhYBcRhQ+nBof6foBTYAiPXtBl3LRkyD20U7vz64JtkVHHjWN986SmlkMcrd0UUyLCX
   HuLy4Ms9/YO5bQRBBzyCNfydDpl8yvmCsiODam00eVxwgI88BCiJ62qACbqoHz68MwUMoShs8xRx
   z6QlJN5z6sCeXZNuozz5c7L4rrv0U7KzvjKYTNEZo0cp3YOHof6+wUkNRAPtJ0B7eYpqUZRiI29Q
   NigXJ8RF061Wa0C7XJp0k16oW0quNDQ2j+4b1KfrrYQAH4och0uP5OrPGp0yAJgcgSIOjEGHLAjs
   JKhUiqu8gRDYENsnn2XCkfbO3vk35CVgCupiXYCXYThZFUEIp+DI7h0VPp78kzDuGLoeNAQ1CSAC
   yeSaaU+88OqEm6UVeVwW+B42lNHDXWMctjFKpXb8k7PvO/ha3uqdwwslKiK2AcedJtxVhsQglVrN
   U6k0IteTkkPnAOGlQyRg1IQFe306cVLmvA1vv/7U/t2bW35rvzc5vydOFHm+9e6adK3ZJC6vqAkZ
   l5nOooE5IRNWcpU6EO/F2T8x3QgLlTIYtDqT0ZZBuuray1d4Qg+RtL2jbxY46Q+3OzDy+HsWP3m8
   X940193iM2TGEMRVkidA0HexvNbPUyToefGZh1+aMWti996vj03WWmwPfr7923QCv2bGA/3FZr3e
   FK+ElOTAr5bh6CjVSaEgxPistPq6ussRA3J5yJMvLGMJREJEptQBDCCEz2M5vDw9rK0dPVwYaBdw
   wvSq2suvHisurpk9fvyPiNk90yZWrNu6B5BiBIWHPPSwNlosNmp7tzSZRoGc3x07Rvq/tn+88rz0
   8PGTbf0KrRfZ9WI02xkg/LSymXQJg8Vs9PfgFU2eM+3Uq489NkjOB0nbd3287o6BffHFF8UGjOIv
   k6vTs6bPm6LR6EY7MMLJZjHl6SkJpXqjic/jMGS40eYB1ApTqTHip+HVxo2m5AnTqk0QkUGu/obG
   Fl9/H3FHW0dv6qpVH/GhoS7D2wE8KCKwsaaxTQcCVJ5r2gDPAaar30PENza3dsegKI0IDw1i0qhM
   Dptg4/fOmnHhvqdenE4WAK/6aWACeQKhQ6vt4djViOBHQNOoOAF8feGFimRSizqkA69rahv4mMvk
   u30sWCBUYLJ/RLDUOkPixx9tfgRM3sbh7o71mzaFnSutuZvOYDmcZhsKXe0HuUYbSMjtGIyezi+Z
   DL7bTmZ7/X28yrUGUwoIPxu5XHYll8UoffrhhZXz5s1zEdWTh76BXnv88Tsu7675eKvfparypKyZ
   92bYzJbRBqMpFjB6q4+3V0d0VOQPIDwzKVVqbo9kMKlq6w7f3EkT3mOxGUaptD8gJzlZ/xOgyUEt
   ffG1EpXBdH9TSwdPoVT6jctKqb/c0OajMivJOmf57Q40KC5u0O9C9SYnhtl1ZusCEPrEq7UGf7AS
   XTPn6SGyA/LAu1RSNmru9ClNYjGHKuLzDL3SwaH2PsLVVdLY1ManU1EHcT2VJoFm0G3XclE4ND4j
   ec/Z/IuLdRYn1+UogFnAgH2n4Dh0/VdxHIalMsWjCx5/Glrw8JL+/bu2fDf7vsXj65p6XiZc+Vxi
   yL24U7tUFMejIoJ7rrR0hJK9YYD4TGiEGnfEQ/HOsWPHfhsVFnE+ZkxC2xNz5hjJeTx1cM8dm2Qy
   5fzvL75JqKquSxg9df54i8WQbrXYxOFR0ba49FRtRHiIxGQ0OxuaW2EwL1mKYpW3A5ggd+8KAnV2
   96Rs3fT+BjpBP319guhHpIRCZzVKmpr1OpNRgBAwG0XAOwyquUcim/hLQF/vt6/X+OWLFllIrSFf
   59w1T6w3q+OdTgSGh/qq+mQD9KEgJspq1VDOXKjy7h9UpMDklg/wcAad4mpK4HJYA/4ikepH40UQ
   0zBzh3AU6uiWTqSgiN1HxCkUCPiFHA6TXVPftAzcJuKahqEqFbmIdDqrd0V10yssFiqrqakpSE1J
   aWho6zc47HbBcKsPudTIL9kcBNLe3R/AYbH6uCxasVDAPAFAJrP9OLg/shAjJcfx5B2CW1c3wN6y
   599J3d194x5csmyaWqcLBCEiKyoi1DZuzHRnclKcTavRWk+dK+ScK7go1hnMFMyJXZ1zBKa43Ax5
   a+AzUUNlg27KlCm6n02Bbly7Uj4qewYI+IkgFEzfldZOPvBv9X2D8qnghj68WQrxRnJG/n492MOv
   uzRdm3ImLF4KKBLqBhcZMs0EMK/m7Bff/GBFXWPLJJXWJEBhd9TpJLOcMMlWcXuwn8/OGxP14Aat
   Lt3D3aQN+CjrD3t3TAwKCiLNO7zz++/9e6SDi1Vqgzep3dmZozuq65tCjEYLmcCCMAxCrFZI/MVX
   +7JffmdZyanzxd3SfmWya2IAQ6QguIbLZjSLuNyytDHpp9etXEGSKKyyEIK+/WILdLuubHh+CgoK
   6Hv3HvYZNFlSgbbmLn7m4YlWu50rEggcsbHRttFpyYi/r4+xqa2DyC+8yN7yxZfUJU8sPl5aWTfL
   ZLaiMDEUS6CwA0VQLZuB9gb4eJ8ODQu6+PIzT16JjIy0/WKZkgRy9JRZpQiMzCYdam9vX2jW6KRT
   P+RfevjY+fO+1+dPf4l93wg2KSGCECNKReUOG+E33HxA6ha4llMs4MoKSyrmgrWFDFeQEATGxVzG
   FbuTYAn4rJLp49N233hOBKUQw5Uq8lsajTb8o8++TLA6rLq/PbhAtmXT9o06ndHbdUawYIpKKsOh
   q6wfHkrMOOn9CtWYULZXUUiAf75eb6RxuaxaHptdOTozqeL9N97oJuel4IeD0Id5b94xkdrwxRfC
   mqrGxMnzF481GIxp4CeBglBovj5e2rmzZ1h9fX1wi81qv9LcyvhqzwFm/4DcXTzC3S5k9/4j80xm
   CwW85WAwaVI2i1pFp9NLEyMjKhYvnNM9aej5r8/Wr7615sDYsJByubJOA6yll0ar8eXyeFbcidsP
   fn90wlDZ7Y6EJD0pE6ZVWW0Wv6EdD8myJgFCoe6+gcEgV7ckicdQ5yxKRfB75k47y6RSDvmLxbJH
   HnnEdMMpqXaHLfBacoNM+mC8wktlX9BRSofo+SVP2G1Og5OAr+v9gIfKj8TVJybpDKpao9OSk2RN
   Tkn/ckJa3I7nnntOQ4J77vC30OoVK+64CbKstin4bPHFMRNm3z9GozOMMpvMQSIhF4uNjdQmxceZ
   wTUGZAolUlVb791z9CRbZzTDZB7JnbiikFkeNxehUszABNX6eouqfEWC0pgQnysffPCBkhxj+RkI
   +mLTryev4Ju1kyZkTd2tN1gmkNFnzviM41ea2kKZdErXxVPfL71Rq35Os29m0mYteHBh7ZXuDaS+
   87nMASoVhUOCArr7+uVhMrnWEyaLKAiB8zjsHi6HezA5Pvrg5g3v997oMg7l5wu+2b3vmbLyuqed
   OIy622zJWhuZhKEQDAZiWbzg7icuNzSNLq28vBxzde4N8W6wuNhMmoLP5xVwWMxibz9hdUB4uOKD
   V14x34kpvn4eGhsbqUWVdYlHT5y6SzGoGK0xmEJxjOAHh/rpxo4Zo4qLjlJ1dXfyrjR3+HT29HGV
   aj3FZLYhQ71kVx9KIBWBRqfqPYT8IiqFkh/o61nhwUYHN4LI6E7Hd1OQJsyc/0hnr+J93MWMuZK4
   qLCzlbWNU7d+9sHsoe5G6NfAvtmAHnrqhYDy2obDNrtV5O3lo5YNDHrjrmoTTJ4DGp+VvJbOYPzw
   +Kcfdv5S1uiBJc9mt7R2f6U3GilmCyDVgDTRqBSCcGCwyyEQGDQmLfaD119bduHDDZt3lFVfprDo
   aKuHhyg/NiSs8LVlS5pu5sfuxNceOXvWQ6e1ZbR2dE43msmijMWXzWY7YqNDdbGRoW2BQQGAiVPo
   EREh8Jv/XJ0CwiAeAmHXZfdcZINAKbCRRkN7hVx+YbCP58mFzz9xZdFNOmPuVG7aeBAQFHipUyIn
   SDoLYlBPL7Gw3+nEPXZv/zoLfHz0ZqDeSsYsLS5UVd/UXBEYEBzT1ikLI9xVeHfgA1457Db1t59v
   bPu184yJi2rrlw4OMBg0r26JikLWeEP9vS1RURHqo6cvBFBQmsNgsgXEhYT0CvnsVx++d07LvJmT
   pOSzThfA97dt+uCOJ4zsnT64c1/Ewieey+3t6Z2oM1oiACtnR0aEOCdNyrZGRoYNmgxme3lFFefE
   maL0AbmaTj5ZwmAyCaPR6noem4zzqcByMagUBZNJvezn63tMwGFXPLJojox8TIgMb/bv+Rz6PQX+
   mdVKicmckm8w2MJJKO6aOnbLpfLahX5+Xj+cOrD79Ztp68+FWD8tB979pEQmf5uA0WsNA4hrn0to
   yeJ73rvc3IyCMMa6c9OGL4Yfn7nZ+DKm3L2rb1Cbg7m8GQyxGbBtas64uqbm1os+AT4FPEFA25bV
   rxtc/Xe/Id1I3tc3Rws8jh77Lluj1k2S9vePNZptIj6fTxsVF41lj8uw8rhca3NrB6u6pp7e0ilF
   TCYL8CXYUOcL5tJamKzww4STxaS2cdmsYj9/z7OeXqKmz9ev1/xe21/ctkaTE5wycWY+WIHhZEDb
   3iVJA4O6OCAbzKqq6meSvOfnTPWvaTZPzKqhqmhGO4ZziKGSBjHULfr1weOvgDCDKuQy+/bsOb4f
   vPlze3PgAf6+xSqNPsNTLKjgcTmng739qoPEAZJNx97TDYO7dc0bdwoucvj0aX8Qik3LmDo7R6s1
   RzoxzNNDyKHNyJ1iHjM6zWIwGOzNLW2M/QeOM6UDCrbBZIYJd7VmKKPmngYURe0CLqucwaCf9ffz
   rPTwFXduWb3aMMw7vtiwAfoj5GebAz1FgkKFWvskCaFEpoi/5+5p5777/mTu/sNfRJIx/i/luH/u
   s4aGBtqOA0esEommz6azRLtzX8PJSRwCMSKdzqDZzGaHb4+iOwpMePnNzke+t6+k5MsXbbZvc3Jy
   dNcfs2LFs3eUaly16gOxDnNGgzFOS5s0a5zNhoUI+GwkODCQWHxfJubj442rtVp7YdElxrFT69gA
   6KGk6HARknD1/FNQ2E5DKYMCPucSl0s/NzEn+1Le8uU/egpj65o10B8tPwu0xWxrYjMYfUarM8Bi
   sjAtRgNg+ZC5U9KXAyam/k7MzevvfPBka4fkZYvNwSQnh0ZFzTaHk0Vcl1f2EvGtgCRTamsbp4Bf
   K6Ab0p7DMkRU7piskOHPgTNnApsaWkePmzl/hlZnTjOazCJ/Hy/b6LQUQ1ZmuoLH4fAqqmto3x87
   iUqk/QhKo2M8LhszGQwo6TDcdRccQgFDZtGQK2IBv4jHZBU+9uC8loULF7qa9/OPHIT+DPKzQL9w
   8jv5O+Om10EAaLKxt61HGs1hM5q6evtzQBixmczv3+7F2BxOo8VqpZE+iyxIJCfF9ZZV1MXAQwVT
   NpNpUyqUdCaLKTfzjerf+2YHBgbY76zbmNDe3TVlySt5U+k0NMBkcTKCA/2sM3MTNbFxUU1SSb+4
   tLKGceTYOXZFTR0LhEfDUTdEwZyA5WspOEwjWCyahIki5d5i0Tkuilbk5GSoX3jhBXL7CuLE93ug
   P5v8oj8dnTtvcV+/Yg3JanlCkWRs5qjD+QWljzy0cHruqtdfl97uxZ58cpnoYmP9d4ARRw0/hQji
   ZjtKRTUsOq195qwpX82fNL5s7Nixyt+y38cwV9i+fTunurHdt0+uTDaZLbkKtXq82WTmCIUiB7kR
   3KSJ4zBvTzFaWlGFny+8yOjslqIYRkDDscBwkgVYGBxBAENmoJ0ePGZJfELkqa3r1zf91jH+KTSa
   FB8xv0apUOkcDpxvsZg9PIVC3OGwobJBDRlm7b/di33++Xpd0rgZVVTEHkSjUzsAiaoVcGmlSRnJ
   VeveektKksB1vxHcQ6dPe3574GjK5LkPZBiMxnSdwZjIAD4iMiLMNG/2dD2VSrEYTRZK45VW+qZt
   X7Hl8kHEiROw04m5wCX3ziZTdBQUtaIoRcKkU8q5XEZ5TEhozc4tn3SR4JacASHaH0Si/hCNzsvL
   Y+z7oWiX1mgfhyAQkZYUva+7W5oMNKKj4Og3f7uTC9731LOxVqtFOGfhvMvDZb3fcgOVBEE9sWFj
   VF1VfbrRak4HWpuu01t8fb094aRRcea4qEgYxx3OftkgXt/YwuzqkTK0eqOrrCcWi4BvRVlytZFi
   stphBhUxCLmMM2BE1UI+tz09Ibx+zZo1OugvIL+a5MiYPPv53kHdCgpgyL5eHm3ePp6VvX2KifWF
   RzJ/Ls79TwvJkj/cujOiorRsYt+gctqgXB5hszs8khJisPTUZGd0dLTdbDY76y9foZeUVTHUWj1i
   MVthskgwvB0Vl03HQwN8jJ1dvTiLQavwEAmKfL28CjxSYvv+/eKLNugvJr/67BXXg38eVeqXwwRB
   V+hM/uOyR++73NiyYPUnm8lyXtUfMUjyL8iUnioSKdXKRJ3eNCEj19VG48PlsKDEuBh8xtTJ2KjE
   WKtMNoCcLbyIbt99kO5wOOFr/ZduV0rm71AUNtIpiDQ2IviCWMAp/Neby8rS09Ov5QV2QH9J+VWg
   Z2WldXW3S2RWOxKC221MzOEU0umo5uKl0tn/KaBJX1tfX8/asGVX3KBCnb5p3ZYMs9WaZrVahUH+
   vo6pk8ZDgf5+NhaDAV1paaMUX6xAt+z8moJhxNWSpbs6Re4SBOE0GnUAjLmKyWRWhvn6lS2cO7Vl
   0aJFrqhh+6ZPoP8LcksdnWkTZq6WqQwPUyAnFB4aVILBsMVkNIZXnT82Ef4dWlaHZduePd7fHzo1
   xmSxpIKYNktrsIYxmTQ0LibckJo8ys6gog6L1c6+0trJAf6WqlQqEXd/2fACIa0z2RUK2Rl0RhuD
   Tq3wEPIvCvm8+heeemhguGb7f1FuCegpcxbmNnX07SRLaRwuR5UUF7HtYkXd68uWPjb55eeXtP4W
   zd365d6wU+fzp8sGZOROewkOu1MkEnKIrKwMbVrKKLleb+KQm9N0dEvYfYMq1GIyIJC7j9Rd2CMQ
   1zYUNApkFfB5FWw69QSLTavkCv37D+3YoPsj8sh/CdNNyrRx6aUdvTKL3UEwjSaTKCEmBr9YXoNf
   KCsle8labwfYN99/X6SQm5N6urumjho/M9tkcQQhMGwOCvQxL8yZ0BUZGd7TLxsQVdU2Brz/wafe
   RpPNtfsPjLt37HKVIQF4CAJbmSikFPG5hRw299y07Mllb7yx9EcMGd750QjCt6PRpIzKnvmlXKOb
   Shb300dFf9/bLwtlMhi2iye/W/BL7Nu9reP+UNmANLOjQzZNozfE2602HpNOk/kF+F5JSYju4vF5
   vJ6e/uSGltaQgUEN2+FwuP5MnxN3J0aRoZ0I6FSqmkmHW7gcznkfkbjg788+0nnjHxoZkd8I9JjJ
   sx+XDqreJTd38fYU9ISF+B6qu9zx+FvPL538+OOLBq4/tm5ggL113cZRLe1t0wZVuhwYc/pYbHYq
   m82sDw7yL4uLDlcCkhXY1dM3Tto/6GezWXnknl7Y0K7ZpHgKOHaxl0eTyWhoAwGRis/iluEIr+be
   GSmapUuXOkag+w+YblI8PPiVfXK1E9hfVKPV+Ofm3t9RWd3ELqkuTwAmeVChULDXfLRtfGl1zayH
   7n001WIxeRMwYhcKhOfHj8tca9BoEIVGP7+7pz+3vqnD3253csm2MWzoCSt3uhtz7cPFZTFbPD0F
   x3Jzx/6QERvbkZOTgw372tOHRkD7jwJNY1MlbDarwWi0JFMpVNhsMAtFAq60rqnlH1nT712mUmuj
   HHYbzGIw2/0CfQsDvD1aUAadDWLu9LLS6iWALYcoNGYvDCf3FXM9MuU2yRTETkMQBYfDauBx6McS
   Y8PLNq9fL3M9SP/9NyMI/dGmOy8vDzlyrvTlAbXh7wiFQkSGBbb5eoo7yqtrkgV8blNYSHCtj5eH
   oX9QE9Pa0THKZLKEWKxOJjTUrH/tcVjyz+NSrDQK3CkS8orEQmFBQrj/XybV+D8PNClzH1uSWFl1
   5YSr6xpQpQfumXVSq9X2t3R2+8sVmlTga0WY3b0BC+HqaxyuM2OASKE6QN7KvL14xXyhR+HktATp
   cFlvBIY/GdDLli1jniqp36M3OzJw3O1ToaE8FIQ4gbJS3JkpBMapCGyk0+AuDotRGxjoc/q1Z5eU
   jf0duxpH5D8INCl3P/C3+Ibmjs0Wu7ufDBn6I0LkMy50KiJjsxjVVCpaGhrkV33gy22N/63Cx4j8
   RqBJmf3AYzFSqXKOE7Mn4ji5Ew/RymTTq+OiAqp2bNyoGAH3LyRkluuTTz6hL8nLY93qLggjMiIj
   8h+W/y/AAElMFdpgRbTEAAAAAElFTkSuQmCC" transform="matrix(1.0929 0 0 1.0929 395.75 239.6607)">
   </image>
   </svg>
    );
}
export const generateReceipt = async (
    clientFirstName: string,
    clientLastname: string,
    clientEmail: string,
    courseName: string,
    description: string,
    currencySymbol: string,
    discount: number,
    paidPrice: number,
    AmountCharged: number,
    FullPrice: number,
) => {

    const theSVGElement = await generateSVGElement(clientFirstName, clientLastname, clientEmail, courseName, description, currencySymbol, discount, paidPrice, AmountCharged, FullPrice);
    const renderSVGElement = ReactDOMServer.renderToStaticMarkup(theSVGElement);
  
    const container = document.createElement('div');
    container.style.display = 'none';
    container.innerHTML = renderSVGElement;
    document.body.appendChild(container);
  
    const svgElement = container.querySelector('svg');
    if (!svgElement) {
      alert('SVG element could not be found!');
      document.body.removeChild(container);
      return;
    }
  
    const receiptWidth = parseFloat(svgElement.getAttribute('width') || '1000');
    const receiptHeight = parseFloat(svgElement.getAttribute('height') || '1300');
    document.body.removeChild(container);
  
    const padding = 100;
  
    const pageWidth = receiptWidth + 2 * padding;
    const pageHeight = receiptHeight + 2 * padding;
    const canvas = document.createElement('canvas');
    canvas.width = receiptWidth;
    canvas.height = receiptHeight;
    const ctx: any = canvas.getContext('2d');
    const v = Canvg.fromString(ctx, renderSVGElement);
    await v.render();
  
    const pngData = canvas.toDataURL('image/png', 1.0);
  
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([pageWidth, pageHeight]);
  
    const pngImageBytes = await fetch(pngData).then((res) => res.arrayBuffer());
    const pngImage = await pdfDoc.embedPng(pngImageBytes);
  
    page.drawImage(pngImage, {
      x: padding,
      y: padding,
      width: receiptWidth,
      height: receiptHeight,
    });
  
    const pdfBytes = await pdfDoc.save();
    return pdfBytes;
    // const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    // const link = document.createElement('a');
    // link.href = URL.createObjectURL(blob);
    // link.download = 'output.pdf';
    // link.click();
  };